// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	font-family: century-gothic, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-font-smoothing: antialiased;
	-moz-osx-font-smoothing: antialiased;
	color: #61869f;
	background-color: #ffffff;
	text-align: center;
	padding: 0px;
	margin: 0px;
}

/* clases generales */

.logo img {
	height: 60px;
    width: auto;
}

.rojo {
    color: brown;
}

p.error {
    color: rgb(117, 17, 17);
	font-size: 12.5px;
}

button,
input[type="submit"],
input[type="button"],
.btn-atras {
    /* width: auto; */
	background-color: #41b6e6;
	color: white;
	border: 0;
	border-radius: 5px !important;
	padding: 10px 15px;
	font-size: 16px;
	font-weight: 500;
	outline: 0;
	cursor: pointer;
    
	/* padding: 8px 12px; */
	/* margin-top: 15px; */

	transition: all 300ms;


    /* 
    margin: 5px;
	font-size: 14px;
	display: inline-block;
     */
}

.filtros {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px 24px;
  align-items: start;
  width: 95%;           /* 🔹 ligeramente más ancho */
  max-width: 1400px;    /* 🔹 más acorde a la tabla */
  margin: 20px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.filtro {
  display: flex;
  flex-direction: column;
}

.filtro label {
  margin-bottom: 4px;
  font-weight: 500;
  color: #333;
}

.filtro input,
.filtro select,
.filtro .select__control {
  width: 100%;
  height: 36px;
  font-size: 14px;
  border-radius: 4px;
}



.filtros label {
  display: block;
  font-weight: 500;
  margin-bottom: 4px; /* antes 6px o más */
  color: #333;
}

/* 🔹 Excepción para checkboxes dentro de filtros */
.filtros label:has(input[type="checkbox"]) {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0; /* eliminamos el espacio innecesario */
  font-weight: 500;
  color: #333;
}


.filtros input,
.filtros select,
.filtros .select__control {
  width: 100%;
  font-size: 14px;
  height: 36px;
  border-radius: 4px;
}


h1.centrar-titulo {
	text-align: center;
}

.acciones-td {
    display: flex;
    /* justify-self: center; */
    width: auto;
    justify-content: start;
}

input {
    border: 1px solid rgb(187, 187, 187);
	transition: all 0.3s;
}

input:hover {
    border: 2px solid gray;
}

.form-group .btn-login{
    width: 100%;
}

.btn-registrate {
    background: white !important;
	color: black;
	margin-bottom: 0px;
	width: 100%;
}
.btn-registrate:hover {
	background: rgb(240, 240, 240) !important;
}
/* Layout */

.layout {
	width: 100%;
	min-height: 100vh;
	display: grid;
	grid-template-areas:
		"header header header header"
		"navi navi navi navi"
		"content content content content"
		"footer footer footer footer";
	grid-template-rows: 100px 70px 1fr 70px;

	/* ✅ CAMBIO CLAVE */
	grid-template-columns: minmax(0, 1fr);
}

.header {
	grid-area: header;
	background: white;
	text-align: left;

	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;
	padding-bottom: 10px;
	width: 100%;
}

.header h1 {
	margin: auto 0;
	margin-left: 15px;
}

.navi {
	grid-area: navi;
	background-color: #41b6e6;
	margin-top: 78px;
	display: grid !important;
	justify-content: space-around !important;
	padding: 7px !important;

}

.navi li {
	padding: 15px;
}

.navi a {
	display: block;
	text-transform: uppercase;
	color: white;
	text-decoration: none;
	font-size: 18px;
	font-weight: 500;
	padding: 15px 20px !important;
	transition: all 300ms;
}


.layout-content {
	grid-area: content;
	min-height: 600px;
	/* padding: 20px; */
	width: 100%;
}

.footer {
	grid-area: footer;
	background: #41b6e6;
	border-top: 1px solid white;
	text-align: center;
	line-height: 68px;
	padding: 0 25px;
	color: white;
}

.footer a {
	text-decoration: none;
	color: white;
}


/* INICIO */
.inicio-container {
    /* height: 60%; */
    width: 100%;
    max-width: 550px;
    margin: auto;
    margin-top: 1%;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    gap: 50px;
}

.titulo-inicio {
    width: 90%;
}

.botones-inicio {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}

.btn-grande {
  display: flex;
  flex-direction: column;   /* Icono arriba, texto debajo */
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 280px;             /* ancho fijo o 100% si quieres adaptativo */
  height: 160px;
  font-size: 1.2rem;
  font-weight: bold;
  background-color: #29a9e0;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.15s ease, background-color 0.2s ease;
}

.btn-grande:hover {
  transform: translateY(-2px);
  background-color: #1f8bbb;
}

.btn-icon-grande {
  font-size: 3rem;    /* 👈 icono grande */
}

.btn-texto {
  display: block;
  text-align: center;
}


/* INICIO TICAJE */
.ticaje-frame {
	height: 100%;
	display: flex;
	flex-direction: column;
	/* justify-content: center; */
	align-items: center;
}

/* GESTION JORNADA lABORAL */

.jornada-activa {
    margin-top: 30px;
    width: 90%;
    min-height: 100px;
    height: auto;
    display: flex;
    flex-direction: column;
}

    .jornada-activa .table-listado {
        width: 100%;
        max-width: 1300px;
    }

.table-listado th,
.table-listado td {
    height: 55px !important;
}

.form-jornada-manual {
  background: #d5dbdc;
  max-width: 450px;
  margin: 50px auto;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
}

.form-jornada-manual label {
  font-weight: 600;
}

.form-jornada-manual .input-layout {
  width: 100%;
}

.form-jornada-manual textarea {
  width: 100%;
  min-height: 60px;
}

.form-jornada-manual button.btn-login {
  align-self: center;
  width: 100%;
}

/* Barra de exportación */
.export-bar {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 1em;
}
.btn-icon-left { margin-right: 6px; }

/* Paginación */
.paginacion-bar {
  width: 90%;
  margin: 0.5rem auto 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.paginacion-controles {
  display: flex;
  align-items: center;
  gap: 8px;
}
.paginacion-estado { min-width: 110px; text-align: center; }
.paginacion-size {
  padding: 6px 8px;
  border-radius: 4px;
}

.consulta-ticajes .distancia-cell {
  display: flex;
  gap: 8px;
  align-items: center;
  white-space: nowrap;
}
.consulta-ticajes .distancia-cell .btn-mapa {
  width: auto;         /* anula el width:100% heredado */
  min-width: 120px;    /* estabilidad visual */
}

.consulta-ticajes .th-multi { display: grid; }
/* Cabeceras con dos líneas */
.consulta-ticajes .th-multi { display: grid; }
.consulta-ticajes .th-multi .th-sub { font-weight: 400; }

/* En-rango */
.consulta-ticajes .estado-cell { display: grid; gap: 4px; }
.consulta-ticajes .estado { font-weight: 700; }
.consulta-ticajes .estado.ok { color: green; }
.consulta-ticajes .estado.ko { color: red; }
.consulta-ticajes .estado.muted { color: #999; font-weight: 600; }

/* Columna Distancia: fija ancho y permite salto si no cabe */
.consulta-ticajes .col-distancia { width: 270px; }       /* ← ajusta si lo necesitas */
.consulta-ticajes .distancia-cell {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;               /* ← permite que los botones bajen a 2ª línea */
}
.consulta-ticajes .distancia-cell .btn-mapa {
  width: auto;                   /* anula width:100% heredado */
  min-width: 120px;
  white-space: nowrap;           /* el texto del botón no parte */
}
.consulta-ticajes .distancia-placeholder { opacity: .7; }

/* (Opcional) hace que las anchuras se respeten mejor */
.consulta-ticajes .table-listado { table-layout: fixed; }
.consulta-ticajes .table-listado th,
.consulta-ticajes .table-listado td { overflow: hidden; text-overflow: ellipsis; }


/* GESTION TICAJE */

.formulario-ticaje {
    width: 90%;
}

.registro-fecha {
	background: rgb(213, 219, 220);

    max-width: 378px;
	margin: 50px auto;
	padding: 30px;

	display: flex;
	flex-direction: column;
	justify-content: center;

	align-items: start;
	/* gap: 15px; */
}

	.registro-fecha label {
		font-weight: 600;

	}

	.registro-fecha button[type="submit"] {
		justify-self: end;
		grid-column: 2/3;
		/* width: 100px; */
	}


	.form-group {
		margin-bottom: 20px;
		width: 100%;
		display: flex;
		flex-flow: row wrap;
		/* justify-content: center; */
	}

		.form-group label {
			flex: 1 1 100%;
			padding-bottom: 5px;
		}

		.form-group select {
			width: 100%;	
		}

		.form-group textarea {
			width: 100%;
			min-height: 44px;
		}

	    .registro-fecha .btn-login {
            color: rgb(255, 255, 255);
            justify-self: center;
            width: 100%;
	    }

	.btn-login:hover {
		background: rgb(57, 146, 159) !important;
	}

	/* TICAJE EN PROCESO */
.ticaje-proceso {
    width: 90%;
    
	margin-top: 20px;
	
	display: flex;
	flex-direction: column;
	justify-content: center;
}


.ticaje-proceso h2 {
	margin-bottom: 30px;
}

.ticaje-proceso .table-listado{
    max-width: 1000px;
}

.th-multi {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  gap: 2px;
}
.th-multi .th-sub {
  font-weight: 400;
  opacity: 0.85;
  font-size: 0.9em;
}

/* Opcional: fija un ancho cómodo para las columnas dobles */
.table-listado th.col-estado { width: 210px; vertical-align: bottom; }
.table-listado th.col-distancia { width: 260px; vertical-align: bottom; }

/* ===== Celdas de Estado (Inicio / Cierre) ===== */
.col-estado .estado-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.estado { font-weight: 600; }
.estado.ok { color: #108548; }   /* verde */
.estado.ko { color: #c2272d; }   /* rojo */
.estado.muted { color: #999; font-weight: 500; }

/* Alineado vertical agradable en estas columnas */
.table-listado td.col-estado,
.table-listado td.col-distancia {
  vertical-align: middle;
}

/* ===== Jornadas (listado): columna Distancia ===== */
.consulta-ticajes .table-listado td.col-distancia {
  vertical-align: middle;
}

.consulta-ticajes .table-listado td.col-distancia .distancia-cell{
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 6px;                 /* igual que Acciones (ajusta a 4–8 si prefieres) */
  min-width: 0;
}

/* Igualar alto con los botones de Acciones */
.consulta-ticajes .table-listado .btn-mapa{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto !important;
  min-width: max-content;
  padding: 0 12px;        /* 👉 sólo horizontal */
  min-height: 34px;       /* 👉 misma “caja” para todos */
  line-height: 1;         /* coherente con el resto de botones */
  white-space: nowrap;
}

/* Placeholder cuando no hay distancia */
.consulta-ticajes .table-listado td.col-distancia .distancia-placeholder {
  color: #666;
}

.consulta-ticajes .table-listado td.col-distancia .btn-mapa{
  min-width: max-content !important;   /* quita el 120px heredado */
  margin: 0 !important;                /* que la separación la marque 'gap' */
  padding: 0 12px;                     /* mismo padding que el resto */
  min-height: 34px;                    /* misma altura que Acciones */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.consulta-ticajes .table-listado .badge{
  background: transparent !important;
  border: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  display: inline !important;

  /* <- lo que arregla el tamaño “pequeño” */
  font-size: inherit !important;
  line-height: inherit !important;

  font-weight: 700;       /* mismo énfasis que “Fuera de rango” */
  color: inherit;
}

/* Reutiliza la misma paleta que usas en En Rango (ok/ko). 
   Si ya tienes .estado.ok / .estado.ko, copia sus colores aquí. */
.consulta-ticajes .table-listado .badge-ok { 
  color: #137a4b; /* mismo verde que uses en tu .estado.ok */
}
.consulta-ticajes .table-listado .badge-ko { 
  color: #d43f3a; /* mismo rojo que uses en tu .estado.ko */
}

/* Línea auxiliar (validador / fecha) */
.consulta-ticajes .table-listado .validada-meta{
  margin-top: 6px;
  color:#555;
  font-size: .95em; /* opcional, para que no compita con el Sí/No */
}

/* En pantallas pequeñas permitimos salto y apretamos un poco */
@media (max-width: 640px) {
  .consulta-ticajes .table-listado td.col-distancia .distancia-cell {
    gap: 4px;
    flex-wrap: wrap;
  }
  .consulta-ticajes .table-listado td.col-distancia .btn-mapa {
    padding: 6px 10px;
    font-size: 0.94rem;
  }
}

.table-listado .col-validada .estado{
  display:inline-block;
  line-height:1.2;
}

/* ---- Solo JORNADAS: columna Acciones ---- */
.consulta-ticajes .table-listado th.col-acciones,
.consulta-ticajes .table-listado td.col-acciones {
  width: 1%;                 /* encoge al contenido */
  white-space: nowrap;
  padding-right: 8px;
}

/* ⚠️ Neutraliza el min-width global de otros listados */
.consulta-ticajes .table-listado td.botones-usuario--jornadas {
  min-width: 0 !important;   /* ← quita el 420px heredado */
  padding-right: 24px !important;   /* separa visualmente de la siguiente columna */
  width: 1%;                 /* deja que encoja */
}

/* Fila de botones más pegados */
.consulta-ticajes .table-listado td.botones-usuario--jornadas .btn-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* Botón compacto solo aquí */
.consulta-ticajes .table-listado td.botones-usuario--jornadas .btn--compact {
  font-size: 0.9rem;
  padding: 6px 10px;
  line-height: 1.1;
  white-space: nowrap;
}

/* Botón-chip de distancia con estado */
.btn-mapa.btn-mapa--chip {
  /* mismas bases que tus botones; solo aseguramos consistencia */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: max-content;
  padding: 6px 12px;
  white-space: nowrap;
  border-width: 1px;
}

/* Estado: en rango */
.btn-mapa.btn-mapa--chip.is-ok {
  background: #e7f8ed;
  color: #0f5132;
  border-color: #b6f0c6;
}
.btn-mapa.btn-mapa--chip.is-ok:hover {
  background: #dff5e7;
}

/* Estado: fuera de rango */
.btn-mapa.btn-mapa--chip.is-ko {
  background: #fdeceb;
  color: #842029;
  border-color: #f5c2c7;
}
.btn-mapa.btn-mapa--chip.is-ko:hover {
  background: #f9e0df;
}

/* Estado: sin dato (cierre no disponible) */
.btn-mapa.btn-mapa--chip.is-muted {
  background: #f1f3f5;
  color: #6c757d;
  border-color: #e9ecef;
}
.btn-mapa.btn-mapa--chip.is-muted:hover {
  background: #e9ecef;
}

/* La fila de distancias queda igual de compacta que acciones */
.col-distancia .distancia-cell {
  display: flex;
  align-items: center;
  gap: 8px;           /* igual que usamos en acciones */
  flex-wrap: nowrap;
  white-space: nowrap;
}


@media (max-width: 1280px) {
  .consulta-ticajes .table-listado td.botones-usuario--jornadas .btn--compact {
    font-size: 0.85rem;
    padding: 6px 8px;
  }
}


/* ===== Extras de calidad de vida ===== */
.ordenable { cursor: pointer; }
.ordenable:hover { text-decoration: underline; }

.table-listado .no-results {
  text-align: center;
  padding: 1rem;
  color: #666;
}

/* Botón de acciones con icono: tamaño consistente */
.table-listado td:last-child .btn-mapa {
  min-width: 36px;
  padding: 6px 10px;
}


/* GESTION ORDENES */
.form-orden {
    width: 90%;
    margin: auto;
}

    .form-orden form {
        max-width: 500px;
        margin-top: 150px;
        
        display: grid;
        grid-template-columns: 2fr 3fr;
        gap: 20px;
    }

    .form-orden textarea {
        height: 70px;
    }
    .form-orden .registro-fecha .btn-login {
        grid-column: span 2;
    }

/* LISTADO ORDENES */

.listado-container {
    width: 90%;
    margin: auto;
}

.listado-container .table-listado-padre {
    margin: auto;
    max-width: 1200px;
}

.listado-container .orden-trabajo {
    min-width: 1200px !important;
}

.listado-container .orden-trabajo td:last-child {
    width: 325px;
}

.listado-container .modal-content {
    width: 500px !important;
}
.listado-container .modal-content .checkbox-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}


/* GESTION CLIENTES */

.cliente-frame {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

	.cliente-frame h1 {
		margin-bottom: 20px;
	}

	.form-agregar-cliente {
		width: 90%;
        margin: auto;
	}

		.form-agregar-cliente form {
			width: 100%;
            max-width: 1300px;
            margin: 20px auto;
            margin-top: 25px;
		}

			.form-agregar-cliente input {
                padding: 0;
                padding-left: 6px;
				height: 44px;
			}
			.form-agregar-cliente button {
                height: 44px;
                border-radius: 0 !important;
			}

    .cliente-frame .filtros {
        max-width: 520px;
        grid-template-columns: repeat(2, 1fr);
    }

    
    
	.tabla-clientes {
		margin-top: 40px;
		width: 90%;
        margin: auto;
	}

        .tabla-clientes .table-listado-padre {
            max-width: 1000px ;
            margin: auto;
        }

        .tabla-clientes .tabla-listado-clientes {
            width: 100%;
            /* max-width: 1300px; */
            margin: auto;
            margin-top: 50px;
            width: max-content;
            table-layout: auto;
            border-collapse: collapse;
		}
        .tabla-clientes th:nth-child(2),
        .tabla-clientes td:nth-child(2) {
            width: 500px !important;
            max-width: 500px !important;
        }


        .acciones-columna {
            display: flex;
            padding: 2px;
            gap: 5px;
            /* max-width: 400px; */
        }
        .acciones-columna button {
            height: 43px;
        }

        .fila-centro td:nth-child(2) {
            max-width: 500px;
        }

		.subtr {
			padding-left: 20px;
		}

        .cliente-frame .table-listado th:nth-child(2),
        .cliente-frame .table-listado td:nth-child(2) {
            width: 400px;
        }
        .cliente-frame .table-listado th:nth-child(3),
        .cliente-frame .table-listado td:nth-child(3)  {
            width: 150px;
        }
        .cliente-frame .table-listado th:nth-child(4),
        .cliente-frame .table-listado td:nth-child(4)  {
            width: 450px;
        }

        .cliente-frame .acciones-td button:last-child{
            width: 130px;
        }
        

/*   TAREAS   */

/* === Contenedor general del formulario de tareas === */
.form-orden {
  max-width: 900px;
  margin: 90px auto 40px;
  padding: 24px 32px 28px;
  border-radius: 12px;
  background: #f3f6f9;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
}

/* Título del bloque */
.form-orden h2 {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 18px;
}

/* === Layout en grid etiqueta / campo === */
.registro-fecha {
  display: grid;
  grid-template-columns: 1.1fr 2fr;
  column-gap: 22px;
  row-gap: 14px;
  align-items: center;
}

/* Etiquetas del formulario */
.registro-fecha label {
  font-weight: 600;
  font-size: 0.95rem;
  color: #29323d;
}

/* Inputs y textarea (usa tu clase estándar) */
.registro-fecha .input-layout,
.registro-fecha textarea,
.registro-fecha input[type="date"],
.registro-fecha input[type="text"] {
  width: 100%;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #d0d7e2;
  font-size: 0.95rem;
  background: #f9fcff;
  box-sizing: border-box;
}

.registro-fecha .input-layout:focus,
.registro-fecha textarea:focus,
.registro-fecha input[type="date"]:focus {
  outline: none;
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(64,169,255,0.2);
}

/* Textarea un poco más alta y alineada */
.registro-fecha textarea {
  resize: vertical;
  min-height: 80px;
}

/* === Bloque prioridad / fecha límite en una sola fila === */
.form-group-inline {
  grid-column: 1 / -1; /* ocupa las dos columnas del grid */
  display: flex;
  gap: 16px;
  margin-top: 4px;
}

.form-group-inline > div {
  flex: 1 1;
}

/* === react-select (classNamePrefix="select") === */
.form-orden .select__control {
  min-height: 38px;
  border-radius: 6px;
  border-color: #d0d7e2;
  box-shadow: none;
  background: #f9fcff;
}

.form-orden .select__control--is-focused {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(64,169,255,0.2);
}

.form-orden .select__placeholder {
  font-size: 0.9rem;
  color: #8b98aa;
}

.form-orden .select__multi-value {
  background: #e8f4ff;
}

.form-orden .select__multi-value__label {
  font-size: 0.85rem;
}

/* que los Selects no se peguen a la etiqueta */
.form-orden .select__control {
  margin-top: 2px;
}

/* === Botón principal === */
.form-orden .btn-login {
  grid-column: 1 / -1;         /* ocupa todo el ancho del formulario */
  margin-top: 10px;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-weight: 600;
  font-size: 0.98rem;
}

.form-orden .btn-login:disabled {
  opacity: 0.7;
  cursor: default;
}

/* === Responsive: en móvil, una sola columna === */
@media (max-width: 768px) {
  .form-orden {
    margin: 80px 12px 30px;
    padding: 20px 18px 24px;
  }

  .registro-fecha {
    grid-template-columns: 1fr;
    row-gap: 10px;
  }

  .registro-fecha label {
    margin-top: 4px;
  }

  .form-group-inline {
    flex-direction: column;
    gap: 10px;
  }
}


/*  TABLEROS KANBAN  */
.kanban-wrapper {
  padding: 20px;
}

.kanban-board {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  overflow-x: auto;
  min-height: 450px;      /* alto mínimo del área del tablero */
  margin-bottom: 40px;    /* separación fija con el botón */
}

.kanban-column {
  background: #f4f6f8;
  border-radius: 8px;
  padding: 8px;
  min-width: 260px;
  max-width: 320px;
  display: flex;
  flex-direction: column;
}

.kanban-column--active {
  background: #e8f6ff;
}

.kanban-column-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px 4px;
  font-weight: 600;
  color: #084298;
  border-bottom: 1px solid rgba(0,0,0,0.06);
}

.kanban-column-count {
  font-size: 0.85rem;
  background: white;
  border-radius: 999px;
  padding: 2px 8px;
  border: 1px solid rgba(0,0,0,0.08);
}

.kanban-column-body {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kanban-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 8px 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  font-size: 0.9rem;
  cursor: grab;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.kanban-card--dragging {
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.2);
}

.kanban-card-title {
  font-weight: 600;
  margin-bottom: 2px;
}

.kanban-card-desc {
  color: #555;
  font-size: 0.85rem;
}

.kanban-card-meta {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 4px;
}

.badge-prioridad {
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 0.75rem;
  text-transform: capitalize;
}

.badge-prioridad--baja {
  background: #e7f8ed;
  color: #0f5132;
}

.badge-prioridad--normal,
.badge-prioridad--media {
  background: #e8f6ff;
  color: #084298;
}

.badge-prioridad--alta,
.badge-prioridad--critica {
  background: #fdeceb;
  color: #842029;
}

.badge-fecha {
  font-size: 0.75rem;
  background: #fff7e6;
  color: #664d03;
  border-radius: 999px;
  padding: 2px 8px;
}

.kanban-card-footer {
  margin-top: 4px;
  font-size: 0.8rem;
  color: #666;
}

.kanban-destino {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kanban-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.kanban-card-avatar img,
.avatar-fallback.avatar-fallback--small {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.kanban-card-header-text {
  display: flex;
  flex-direction: column;
}

.kanban-card-creator-name {
  font-weight: 600;
  line-height: 1.1;
}

.kanban-card-creator-label {
  font-size: 0.8rem;
  color: #777;
}

/* Semáforo fecha */
.badge-fecha--ok {
  background: #e6f4ea;
  color: #0f5132;
}

.badge-fecha--warning {
  background: #fff3cd;
  color: #664d03;
}

.badge-fecha--critica {
  background: #f8d7da;
  color: #842029;
}


/* Botón similar a tus botones azules */
.btn-toggle-desplegable {
  background-color: #29abe2;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
}

.btn-toggle-desplegable:hover {
  background-color: #1b8cbc;
}


.tareas-creadas-desplegable {
  margin-top: 40px !important; /* antes 30px */
}

/* El card blanco del desplegable ocupa todo el ancho */
.tareas-creadas-desplegable-body {
  margin-top: 15px;
  padding: 20px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  width: 100%;
  box-sizing: border-box;
}

.tabla-clientes--embebida {
  max-width: none !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* La tabla ocupa todo el ancho disponible */
.tabla-listado-clientes {
  width: 100%;
  table-layout: auto;
}

.tabla-listado-clientes th:nth-child(1),
.tabla-listado-clientes td:nth-child(1) {
  width: 40%;
}

.tabla-listado-clientes th:nth-child(2),
.tabla-listado-clientes td:nth-child(2),
.tabla-listado-clientes th:nth-child(3),
.tabla-listado-clientes td:nth-child(3),
.tabla-listado-clientes th:nth-child(4),
.tabla-listado-clientes td:nth-child(4),
.tabla-listado-clientes th:nth-child(5),
.tabla-listado-clientes td:nth-child(5) {
  width: 12%;
}

.tabla-listado-clientes th:nth-child(6),
.tabla-listado-clientes td:nth-child(6) {
  width: 22%;
}

.peticiones-horizontal {
  display: flex;
  flex-wrap: wrap;           /* por si en pantallas pequeñas se rompe */
  gap: 4px 10px;
  font-size: 0.85rem;
  line-height: 1.2;
  justify-content: flex-start;
  width: 100%;
  white-space: nowrap;       /* intenta mantenerlo en una sola línea */
}


/* Tabla de "tareas creadas por mí" dentro de tabla-clientes */
.tabla-listado-tareas-creadas {
  width: 100%;
}

/* Reparto de columnas solo para esta tabla */
.tabla-listado-tareas-creadas th:nth-child(1),
.tabla-listado-tareas-creadas td:nth-child(1) {
  width: 32%;   /* Título */
}

.tabla-listado-tareas-creadas th:nth-child(2),
.tabla-listado-tareas-creadas td:nth-child(2) {
  width: 10%;   /* Prioridad */
}

.tabla-listado-tareas-creadas th:nth-child(3),
.tabla-listado-tareas-creadas td:nth-child(3) {
  width: 13%;   /* Estado global */
}

.tabla-listado-tareas-creadas th:nth-child(4),
.tabla-listado-tareas-creadas td:nth-child(4),
.tabla-listado-tareas-creadas th:nth-child(5),
.tabla-listado-tareas-creadas td:nth-child(5) {
  width: 13%;   /* Fechas */
}

/* Columna de peticiones: más ancha y con mínimo */
.tabla-listado-tareas-creadas th.col-peticiones,
.tabla-listado-tareas-creadas td.col-peticiones {
  width: 19%;
  min-width: 240px;
}

/* Versión embebida de la tabla (debajo del tablero) */
.tabla-clientes--embebida {
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Aquí rompemos el centrado de .tabla-clientes .tabla-listado-clientes */
.tabla-clientes--embebida .tabla-listado-clientes {
  width: 100% !important;
  margin: 20px 0 0 0 !important;   /* margen solo arriba */
  text-align: left;
}

.tareas-depto-filtros {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.tareas-depto-label {
  font-weight: 600;
}

.tareas-depto-select {
  max-width: 260px;
}

.tareas-depto-loading,
.tareas-depto-empty {
  font-style: italic;
  color: #666;
}

.tareas-depto-hint {
  font-style: italic;
  margin-bottom: 20px;
  color: #666;
}

/* Departamento asociado en tarjeta */
.kanban-card-depto {
  margin-bottom: 4px;
}

.kanban-depto-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef2ff;   /* azul muy suave */
  color: #312e81;        /* azul oscuro */
  font-size: 0.75rem;
  font-weight: 500;
}


.tarea-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tarea-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  border-bottom: 1px solid rgba(0,0,0,0.06);
  padding-bottom: 8px;
}

.tarea-panel-title {
  margin: 0;
  font-size: 1.1rem;
}

.tarea-panel-subtitle {
  margin: 4px 0 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tarea-panel-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.75rem;
  background: #f4f6f8;
}

.prioridad-baja { background: #e7f8ed; color: #0f5132; }
.prioridad-normal { background: #e8f6ff; color: #084298; }
.prioridad-alta { background: #fff3cd; color: #664d03; }
.prioridad-critica { background: #fdeceb; color: #842029; }

.tarea-panel-header-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  font-size: 0.8rem;
  color: #666;
}

.tarea-panel-meta-item {
  white-space: nowrap;
}

.tarea-panel-body {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.tarea-panel-col {
  flex: 1 1;
  min-width: 0;
}

.tarea-panel-col--info {
  border-right: 1px solid rgba(0,0,0,0.06);
  padding-right: 12px;
}

.tarea-panel-section-title {
  margin: 0 0 8px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}

.tarea-panel-descripcion {
  margin: 0 0 12px;
  font-size: 0.9rem;
}

.tarea-panel-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0,1fr));
  gap: 8px 16px;
  font-size: 0.85rem;
}

.tarea-panel-info-label {
  display: block;
  color: #777;
  font-size: 0.8rem;
}

.tarea-panel-info-value {
  font-weight: 600;
}

.tarea-panel-field {
  margin-bottom: 12px;
}

.tarea-panel-label {
  display: block;
  margin-bottom: 4px;
  font-size: 0.85rem;
  font-weight: 600;
}

.tarea-panel-help {
  display: block;
  margin-top: 4px;
  font-size: 0.75rem;
  color: #777;
}

.tarea-panel-textarea {
  resize: vertical;
}

.tarea-panel-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
  border-top: 1px solid rgba(0,0,0,0.06);
  padding-top: 8px;
}

/* Botones coherentes con tu estilo */
.btn-principal {
  background-color: #29abe2;
  border: none;
  color: #fff;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 0.9rem;
  cursor: pointer;
}

.btn-principal:disabled {
  opacity: 0.6;
  cursor: default;
}

.btn-secundario {
  background-color: #f4f6f8;
  border: 1px solid #d0d7de;
  color: #333;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 0.9rem;
  cursor: pointer;
}

@media (max-width: 768px) {
  .tarea-panel-body {
    flex-direction: column;
  }
  .tarea-panel-col--info {
    border-right: none;
    padding-right: 0;
    border-bottom: 1px solid rgba(0,0,0,0.06);
    padding-bottom: 12px;
    margin-bottom: 12px;
  }
}

/* --- MODAL CENTRADO Y POR ENCIMA DE NAVBAR --- */
.modal-historial-overlay {
  position: fixed;
  inset: 0;                        /* top:0,left:0,width/height 100% */
  background: rgba(0,0,0,0.45);
  z-index: 999999;                 /* por encima de la navbar */
  display: flex;
  justify-content: center;
  align-items: flex-start;         /* 👈 evita deformaciones con scroll */
  overflow-y: auto;                /* 👈 scroll del overlay cuando haga falta */
  padding: 40px 16px;              /* margen superior/inferior para respirar */
}

/* --- CONTENEDOR DEL HISTORIAL --- */
.modal-historial-contenido {
  background: #fff;
  width: 900px;
  max-width: 90vw;
  border-radius: 12px;
  position: relative;
  padding: 30px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 35px rgba(0,0,0,0.25);
}

/* --- X DE CERRAR --- */
.historial-close-btn {
  position: absolute;
  top: 12px;
  right: 22px;
  font-size: 22px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 10;
}

/* --- SCROLL INTERNO, SIEMPRE 1 COLUMNA --- */
.historial-scroll {
  margin-top: 10px;
  padding-right: 12px;
  overflow-y: auto;
  max-height: 70vh;                /* 👈 límite de alto del listado */
}

/* --- TARJETA DEL EVENTO DEL HISTORIAL --- */
.historial-item-card {
  width: 100%;
  background: #f9f9f9;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 14px;
  display: block;                  /* 👈 garantizamos una sola columna */
}

/* --- CABECERA DEL EVENTO: AVATAR + NOMBRE + FECHA --- */
.historial-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar-small {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  color: #555;
  font-size: 15px;
}

.historial-header-text {
  display: flex;
  flex-direction: column;
}

.historial-user {
  font-weight: bold;
  font-size: 14px;
}

.historial-date {
  font-size: 12px;
  opacity: 0.8;
}

/* --- TEXTO DESCRIPTIVO --- */
.historial-body {
  margin-top: 8px;
  font-size: 14px;
  color: #444;
}

.historial-comentario {
  margin-top: 6px;
  padding-left: 6px;
  border-left: 3px solid #aaa;
  font-style: italic;
  opacity: 0.9;
}


/* ControlSIL */

/* =========================
   SIL Control - Editor
========================= */

/* Layout general del editor */
.sil-grids {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 16px;
  align-items: start;
}

.sil-toolbar {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 14px;
}

.sil-info { margin-left: 10px; }
.sil-modal-sub { margin-top: -8px; }
.muted { opacity: .65; }
.rojo { color: #c0392b; }

/* Tablero */
.sil-grid-contenedor--tablero {
  position: relative;
  width: 100%;
  overflow: auto;
  background: #fff;        /* limpio */
}


.sil-grid-contenedor--tablero > .react-grid-layout{
  min-height: 100% !important;
}

.sil-celda-hover{
  position: absolute;
  pointer-events: none;
  background: rgba(255,0,0,.12);
  border: 1px solid rgba(255,0,0,.35);
  border-radius: 8px;
  z-index: 10;
}

.sil-modo-colocar{ cursor: crosshair; outline: 2px dashed rgba(65,182,230,.8); }



/* Badge de modo colocar */
.sil-badge-colocar {
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(65, 182, 230, 0.15);
}

/* Banco */
.sil-grid-bloque--banco {
  position: sticky;
  top: 90px; /* navbar fixed-top */
}

.sil-banco {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sil-banco-item {
  background: #fff;
  border-radius: 10px;
  border: 1px solid rgba(0,0,0,.08);
  padding: 10px;
}

.sil-banco-titulo { font-weight: 700; font-size: 13px; }
.sil-banco-sub { font-size: 12px; margin-top: 4px; }
.sil-banco-acciones { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 10px; }

.sil-btn-cancelar-colocar {
  margin-top: 10px;
}

/* Tarjetas del grid */
.sil-nodo-card {
  background: #fff;
  border-radius: 10px;
  border: 1px solid rgba(0,0,0,.08);
  overflow: hidden;
  height: 100%;
}

.sil-nodo-card-inner{
  height: 100%;
  padding: 10px 12px;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;   /* 👈 CLAVE */
  gap: 6px;                      /* separación natural */
}

..sil-nodo-titulo {
  font-weight: 700;
  font-size: 13px;
  line-height: 1.15;
}

.sil-nodo-usuario {
  font-size: 12px;
  color: #555;
}

/* Acciones en UNA fila */
.sil-nodo-acciones {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;   /* 👈 evita stacking vertical */
  margin-top: auto;    /* 👈 empuja botones abajo SIN estirar todo */
}


.sil-checkbox { display: flex; gap: 8px; align-items: center; }

/* ✅ Botones compactos SOLO en SIL */
.sil-nodo-acciones .btn-mapa{
  padding: 6px 10px !important;
  font-size: 12px !important;
  border-radius: 6px !important;
  min-height: 30px;
}

/* Lienzo de ControlSIL */
/* Toolbar bonita */
.sil-toolbar{
  display:flex;
  gap:10px;
  align-items:center;
  flex-wrap:wrap;
}

.sil-canvas-controls{
  display:flex;
  gap:10px;
  align-items:center;
  padding:8px 10px;
  border:1px solid rgba(0,0,0,.08);
  border-radius:10px;
  background:rgba(255,255,255,.85);
}

.sil-canvas-title{
  font-weight:700;
  font-size:13px;
  opacity:.8;
  margin-right:6px;
}

.sil-canvas-controls label{
  display:flex;
  flex-direction:column;
  gap:4px;
  font-size:12px;
}

.sil-canvas-controls input{
  width:90px;
  padding:6px 8px;
  border:1px solid rgba(0,0,0,.15);
  border-radius:8px;
}

/* Tarjetas */
.sil-nodo-card { height: 100%; }

.sil-nodo-card-inner{
  height:100%;
  padding:10px 12px;
  border:1px solid rgba(0,0,0,.10);
  border-radius:10px;
  background:#fff;
  display:flex;
  flex-direction:column;
  justify-content:flex-start;
  gap:6px;
}

.sil-nodo-titulo{ font-weight:700; font-size:13px; line-height:1.15; }
.sil-nodo-usuario{ font-size:12px; color:#555; }
.sil-nodo-usuario.muted{ opacity:.6; }

.sil-nodo-acciones{
  display:flex;
  gap:6px;
  flex-wrap:nowrap;
  margin-top:auto;
}

.sil-nodo-acciones .btn-mapa{
  padding:6px 10px !important;
  font-size:12px !important;
  border-radius:6px !important;
  min-height:30px;
}


/* =========================
   PANEL REPORTES SIL
========================= */

.sil-panel {
  padding: 20px;
}

.sil-panel-title {
  margin-bottom: 10px;
}

.sil-panel-loading {
  padding: 20px;
}

.sil-panel-error {
  color: #c0392b;
  margin-bottom: 12px;
}

/* Scroll horizontal superior */
.sil-panel-scroll-top {
  overflow-x: auto;
  height: 16px;
  margin-bottom: 6px;
  border-radius: 8px;
  border: 1px solid rgba(0,0,0,.06);
  background: rgba(255,255,255,.7);
}

/* Canvas principal */
.sil-panel-canvas {
  height: calc(100vh - 220px);
  overflow: auto;
  border: 1px solid rgba(0,0,0,.06);
  border-radius: 10px;
  background: #fff;
}

/* =========================
   TARJETAS
========================= */

.sil-reporte-card {
  height: 100%;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  cursor: default;
}

/* Estados */
.sil-reporte-verde {
  background: #dff6e4;
  border: 1px solid rgba(39,174,96,.35);
}

.sil-reporte-amarillo {
  background: #fff4cc;
  border: 1px solid rgba(241,196,15,.45);
}

.sil-reporte-rojo {
  background: #ffe0e0;
  border: 1px solid rgba(192,57,43,.35);
}

.sil-reporte-expirado {
  background: #ffffff;
  border: 1px dashed rgba(0,0,0,.25);
}

/* Contenido */
.sil-reporte-titulo {
  font-weight: 800;
  line-height: 1.15;
}

.sil-reporte-usuario {
  font-size: 13px;
  color: #777;
}

.sil-reporte-fecha {
  font-size: 12px;
  color: #777;
  text-align: right;
}


/* TICAJE DE EMPLEADOS */
.ticaje-empleados {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
        
	.consulta-ticajes {
		width: 90%;
        margin: auto;
	}

		.consulta-ticajes h2 {
			margin-bottom: 20px;
            text-align: start;
		}

        .consulta-ticajes th {
            color: black;
            cursor: pointer;
            transition: color .1s ease;
        }
        
        .consulta-ticajes th:hover {
            color: rgb(113, 113, 113);
            
        }

		.consulta-ticajes .btn-mapa {
			width: 100%;
            max-width: 87px;
            /* margin: 8px 0; */
		}
	
        .table-listado-padre {
            margin-top: 10px;
            /* max-width: 100%; */
            overflow-x: auto;
            width: 100%;
        }
        
            .table-listado-padre .table-listado {
                /* margin: 0; */
                min-width: 1500px;
                width: max-content;
                table-layout: auto;
                border-collapse: collapse;
            }

            /* .consulta-ticajes .table-listado th:nth-child(1) {
                width: 75px;
            }

            .consulta-ticajes .table-listado th:nth-child(3) {
                width: 275px;
            }
            .consulta-ticajes .table-listado th:nth-child(2),
            .consulta-ticajes .table-listado th:nth-child(4),
            .consulta-ticajes .table-listado th:nth-child(5) {
                width: 150px;
            }
            .consulta-ticajes .table-listado th:nth-child(6) {
                width: 120px;
            } */

            .consulta-ticajes .table-listado th,
            .consulta-ticajes .table-listado td {
                padding-right: 20px;
            }

            .acciones-td {
                white-space: wrap;
                min-width: 100px;
                margin: 2px;
            }

        .exportar-botones-padre {
            width: 100%;
            display: flex;
            justify-content: end;
        }
        .exportar-botones {
            /* width: 40%; */
            display: grid;
            grid-template-columns: repeat(4,160px);
            /* justify-content: end; */
            align-items: center;
            gap: 10px;
            margin-top: 1em;
        }
        .exportar-botones .btn-mapa {
            max-width: none;
            width: 100%;
        }
        

	.fingerprint-checker {
		width: 90%;
		margin-top: 25px;
		margin-bottom: 35px;
	}

		.fingerprint-checker button {
			margin-top: 5px;
		}

		.fingerprint-checker p {
			margin-top: 10px;
			margin-bottom: 0;
		}


/* CREAR USUARIOS */
.form-crear-usuario {
    width: 90%;
    margin: auto;
}
.formulario-usuario {
    background: #D5DBDC;
    width: auto;
    max-width: 600px;
    margin: auto;
    margin-top: 100px;
    padding: 20px;

    display: grid;
    grid-template-columns: repeat(2, 1fr);

    align-items: center;
    column-gap: 20px;
}

.formulario-usuario select {
    width: 100%;
    max-width: 187px;
    height: 28px;
}

.formulario-usuario button {
    width: 100%;
    max-width: 187px;
    height: 050px;
}

/* Mantener tu layout de 2 columnas tal cual ya lo tengas */

/* Contenedor input + botón compacto */
.input-with-button {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 8px;
}

/* Asegura que el input ocupa todo el ancho disponible */
.input-with-button input {
  width: 100%;
  box-sizing: border-box;
}

/* Botón ojo compacto, mismo alto que el input sin desbordar */
.btn-eye {
  border: none;
  cursor: pointer;
  padding: 0 10px;
  height: 32px;            /* ajusta a tu altura de input */
  min-width: 38px;
  border-radius: 4px;
  background: #29a9e0;     /* tu color de botones (como .btn-login light) */
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

/* Versión accesible para lectores de pantalla */
.sr-only {
  position: absolute;
  width: 1px; height: 1px;
  padding: 0; margin: -1px;
  overflow: hidden; clip: rect(0,0,0,0);
  white-space: nowrap; border: 0;
}

/* Si tus inputs son más altos, sincroniza: */
.formulario-usuario input[type="text"],
.formulario-usuario input[type="email"],
.formulario-usuario input[type="password"],
.btn-eye {
  height: 34px;            /* mismo valor para todos para que alineen */
}

/* Opcional: que el botón no crezca en móvil */
@media (max-width: 640px) {
  .input-with-button { gap: 6px; }
  .btn-eye { height: 32px; min-width: 34px; padding: 0 8px; }
}


/* GESTION USUARIOS */
.usuarios-page {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

    .usuarios-page h2 {
        width: 90%;
        text-align: start;
        margin: 0;
        
    }

    .registro-usuarios {
        width: 85%;
        margin-top: 15px;
        margin: 20px 0;
    }
    
        .registro-usuarios button {
            width: auto;
        }


        /* REGISTRAR NUEVO USUARIO */
            .registro-usuarios .modal-form {
                display: grid;
                grid-template-columns: repeat(2, auto 1fr);
            }

            .modal-form button {
                grid-column-end: -1;
                width: 100% !important;
            }
        

    
    .gestion-usuarios {
        width: 90%;
        margin: auto;
    }

        .gestion-usuarios .modal-content {
            max-width: 600px;
        }

        .editar-user {
            max-width: 700px !important;
        }

            .modal-options {

                margin: 20px 0;

                display: flex;
                justify-content: center;
                align-items: center;
                gap: 20px;
            }

            .modal-options select{
                width: 50%;
                max-width: 130px;
                height: 44px;
                border-radius: 5px;
            }

    .table-listado {
        width: 90%;
        /* border-collapse: collapse; */
        margin: 20px auto;
        text-align: left;
    }

    .gestion-usuarios .table-listado {
        max-width: 1300px !important;
        min-width: 1117px !important;

    }

    .gestion-usuarios .table-listado th:nth-child(1) {
    width: 130px; /* DNI */
    }
    .gestion-usuarios .table-listado th:nth-child(2) {
    width: 240px; /* Nombre */
    }
    .gestion-usuarios .table-listado th:nth-child(3) {
    width: 240px; /* Apellidos */
    }
    .gestion-usuarios .table-listado th:nth-child(4) {
    width: 240px; /* Email */
    }
    .gestion-usuarios .table-listado th:nth-child(5) {
    width: 120px; /* Teléfono */
    }
    .gestion-usuarios .table-listado th:nth-child(6) {
    width: 100px; /* Rol */
    }
    .gestion-usuarios .table-listado th:nth-child(7) {
    width: 140px; /* Manager */
    }
    .gestion-usuarios .table-listado th:nth-child(8) {
    min-width: 400px; /* Acciones */
    }


    .gestion-usuarios .table-listado td:last-child {
        display: grid;
        grid-template-columns: repeat(4, 91px);
        gap: 5px;
        padding-right: 10px !important;
    }
    .gestion-usuarios .table-listado td:last-child button {
        width: 100%;
    }

        .gestion-usuarios .acciones-td .btn-mapa:last-child{
            width: 82px;
        }

        /* Ajustar botones dentro de la tabla */
        .table-listado td button {
            margin: 5px;
            padding: 8px 12px;
            font-size: 14px;
            border-radius: 5px;
            /* display: inline-block; */
        }

        .table-listado th {
            color: black;
            transition: color .2s ease;
        }
        
        .ordenable:hover {
            color: rgb(113, 113, 113);
        }
    
.gestion-usuarios .acciones-td.flex {
  display: table-cell !important;
}

.gestion-usuarios .acciones-td.flex .button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-start;
}

.gestion-usuarios .acciones-td.flex .button-container button {
  width: auto !important;
  flex: 0 0 auto;
  white-space: nowrap;
}

td.botones-usuario {
  display: table-cell !important;
  white-space: nowrap;
  min-width: 420px;
}


td.botones-usuario .btn-mapa {
  width: auto !important;
  display: inline-block !important;
  flex: 0 0 auto;
  white-space: nowrap;
  margin: 2px;
}

.td-invisible {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  visibility: hidden !important;
}

/* Formulario de edición (modal) */
    .formulario-usuario-editar {
    background: #D5DBDC;
    max-width: 434px;
    margin: auto;
    margin-top: 100px;
    padding: 20px;

    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
    row-gap: 16px;
    }

    .formulario-usuario-editar h2 {
    grid-column: 1 / -1;
    text-align: center;
    margin-bottom: 10px;
    }

    .formulario-usuario-editar .form-group {
    display: flex;
    flex-direction: column;
    }

    .formulario-usuario-editar .form-group.full-width {
    grid-column: 1 / -1;
    }

    .formulario-usuario-editar button {
    width: 100%;
    max-width: 187px;
    justify-self: start;
    }

/* Tabla ancha reutilizable */
.table-listado--wide {
  width: 96% !important;
  max-width: 1400px;
  min-width: 1100px;
  margin: 16px auto;
}

/* Quita límites antiguos de usuarios si te están estrechando la tabla */
.gestion-usuarios .table-listado {
  max-width: unset !important;
  min-width: unset !important;
}


/* Toast minimalista */
.toast {
  position: fixed;
  top: 20px; left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  padding: 12px 18px;
  border-radius: 8px;
  color: #111;
  background: #e8f6ff;
  box-shadow: 0 8px 24px rgba(0,0,0,.12);
  font-weight: 600;
  animation: toastIn .2s ease-out;
}
.toast.ok    { background: #e7f8ed; color: #0f5132; border: 1px solid #b6f0c6; }
.toast.error { background: #fdeceb; color: #842029; border: 1px solid #f5c2c7; }
.toast.info  { background: #e8f6ff; color: #084298; border: 1px solid #b6d9ff; }

@keyframes toastIn { from { opacity: 0; transform: translate(-50%, -6px); } to { opacity: 1; transform: translate(-50%, 0); } }

/* Fade-in para el bloque activo */
.ticaje-frame > * {
  animation: fadeIn .18s ease-out;
}
@keyframes fadeIn { from { opacity: 0; transform: translateY(4px);} to { opacity: 1; transform: translateY(0);} }

/* AVATARES */
.avatar-lista {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.avatar-lista img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-fallback {
  width: 100%;
  height: 100%;
  border-radius: 999px;
  background: #ddd;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.8rem;
}

/* Fuerza que el contenido del nodo sea horizontal */
.org-chart .nodo-org {
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #29a9ec;
  color: #fff;
}

/* Avatar del nodo */
.org-chart .nodo-org-avatar {
  flex: 0 0 auto;
}

/* Reutilizamos el estilo de avatar de la tabla */
.org-chart .avatar-lista {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
}

.org-chart .avatar-lista img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.org-chart .avatar-fallback {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #d0d0d0;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* Texto del nodo */
.org-chart .nodo-org-texto {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.org-chart .nodo-org-nombre {
  font-weight: 700;
}

.org-chart .nodo-org-rol {
  opacity: 0.9;
  font-size: 0.85em;
}

/* --- Corrección del ancho excesivo --- */
.org-chart .nodo-org {
  width: max-content;          /* La tarjeta ocupa sólo lo necesario */
  max-width: 360px;            /* Evita tarjetas gigantes */
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #29a9ec;
  color: #fff;
  margin: 6px 0;
  box-sizing: border-box;
}

/* Esto evita que <li> fuerce el ancho completo */
.org-chart li {
  width: auto;
  display: block;
}

.nav-user-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.avatar-navbar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  overflow: hidden;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
}

.avatar-navbar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-fallback-navbar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  color: #555;
}

.nav-user-name {
  font-weight: 600;
}

.subtabla-centros--usuarios .th-avatar,
.subtabla-centros--usuarios .td-avatar {
  width: 56px !important;
  padding-left: 12px;
  padding-right: 12px;
}

.subtabla-centros--usuarios td:nth-child(2) {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.avatar-lista img,
.avatar-fallback {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
}



/* ----- Jornadas: columna Acciones ----- */
.consulta-ticajes .table-listado td.botones-usuario--jornadas {
  overflow: visible !important;      /* nada de recortes */
  text-overflow: initial !important;
  white-space: normal;               /* deja que el contenedor gestione el flujo */
  padding-right: 0;                  /* coherencia con Usuarios */
}

/* Fila de botones (misma separación que Usuarios) */
.consulta-ticajes .table-listado td.botones-usuario--jornadas .btn-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;                 /* todos en una línea */
  gap: 6px;                          /* <- ajusta aquí si quieres más/menos aire */
  min-width: 0;                      /* evita efectos colaterales del td */
}

/* Botones: que no sumen márgenes y se adapten al texto */
.consulta-ticajes .table-listado td.botones-usuario--jornadas .btn-mapa {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;                         /* importante: que el gap mande */
  width: auto !important;
  min-width: max-content;            /* el ancho crece con el texto */
  white-space: nowrap;               /* el texto no parte en varias líneas */
  line-height: 1;                    /* evita cortes verticales raros */
  padding: 8px 14px;                 /* look & feel como en Usuarios */
}

/* Alinear SIEMPRE a la izquierda en tablas de departamentos */
.tabla-listado-clientes th,
.tabla-listado-clientes td,
.subtabla-centros--usuarios th,
.subtabla-centros--usuarios td {
  text-align: left !important;
}

/* Evitar centrado automático en columnas estrechas */
.subtabla-centros--usuarios th.th-avatar,
.subtabla-centros--usuarios td.td-avatar {
  text-align: center !important; /* Solo el avatar centrado */
}




/* Ajustes */
.ajustes {
    display: flex;
    flex-direction: column;
    align-items: center;
}

    .cambiar-contrasena {
        width: auto;
        margin-top: 10px;
    }

        .cambiar-contrasena h2 {
            margin-bottom: 45px;
        }
    
        .cambiar-contrasena form {
            background: rgb(226, 226, 226);
            margin-top: 20px;
            padding: 20px;

            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 0 20px;
        }

            .cambiar-contrasena .form-group {
                grid-column: span 2;

                display: grid;
                grid-template-columns: subgrid;
                align-items: center;
                /* justify-items: center; */

            }

        .cambiar-contrasena button {
            grid-column: span 2;
            width: auto;

        }


/* Login */
.layout_identificarse {
	background: rgb(226, 226, 226);
	width: 360px;
	height: auto;
	margin: 70px auto;
	text-align: center;
	padding: 20px;

	display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;

}

    .layout_identificarse h2 {
    	color: #41b6e6;
        margin-top: 15px;
        margin-bottom: 30px;
    }
    
        .content-form .form-group {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;   
            justify-items:flex-end;
        }

        .content-form div:last-child {
            margin: 25px 0;
        }

            .content-form .form-group svg {
                margin-right: 10px;
            }


/* Modal */
.modal-overlay {
    position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3) !important;
	display: flex;
	justify-content: center;
	align-items: center;
}

    .modal-close {
        color: black;
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 30px;
        cursor: pointer;
    }

    .modal-content {
        background-color: white !important;
        width: 70% !important;
        height: auto !important;
        margin-bottom: -200px !important;
        padding: 50px;
        border-radius: 8px;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
        overflow-y: auto !important;

        display: flex;
        flex-flow: wrap row;
        gap: 10px;
    }
        .modal-content form {
            display: flex;
            flex-direction: column;
            gap: 20px;
        }

            .nombre-centro {
                display: flex;
                gap: 10px;
            }

            .modal-content form button {
                width: 150px;
            }

            .modal-content .reset {
                width: 100px;
            }








/* No tocar por ahora */
.item-menu {
    align-items: center !important;
    transition: all 300ms ease;
    align-self: center;
}

.item-menu:hover {
    background: #2699c7;
}

#basic-navbar-nav {
    background-color: #41b6e6;
}

.input-layout {
    /* width: 70%; */
	padding: 10px;
	/* margin-left: 7px; */
	border: transparent;
	border-bottom: 1px solid black;
	transition: all 0.3s ease;
	background: rgb(227, 241, 243);
}

.input-layout:hover {
    border: transparent;
	border-bottom: 1px solid black;
	background: rgb(255, 255, 255);
}

.input-layout:focus {
	outline: none;
	border-bottom: #2699c7 2px solid;
	transition: none;
	background: white;
}

.input-layout:focus::placeholder {
    transform: translateY(-15px);
	font-size: 12px;
	color: #999;
	transition: all 0.3s ease;
}

.icon-login {
    align-self: center;
}





.iniciar-sesion {
    color: black;
	margin-right: 120px;
}

.iniciar-sesion:hover {
    color: rgb(68, 68, 68);
}

.listado {
    margin-top: 20px;
	margin-bottom: 20px;
}

.tam {
    width: 40% !important;
}


.tr-header-listado {
	background: #9de3ff;
	font-size: 18px;
    padding: 10px;
    transition: all 0.3s;
}

tr:nth-child(even) {
    background: #e6e6e6;
}


.th-header-listado:hover {
    cursor: pointer;
	background: rgb(136, 207, 235);
}

.tr-body-listado td {
    padding: 10px;
	border-bottom: 1px solid rgb(155, 197, 199);
}

/* Alternar colores en filas */
.tr-body-listado:nth-child(even) {
    background: #f8f8f8;
}

.tr-body-listado:nth-child(odd) {
	background: #ffffff;
}

/* Alinear correctamente los centros */
.tr-body-listado.centro-trabajo {
    background: #e6e6e6;
	padding-left: 120px;
}

.subtabla-centros {
    width: 100%;
    border-collapse: collapse;
    margin: 0;
    padding: 0;
    background-color: transparent;
}

.subtabla-centros th,
.subtabla-centros td {
    padding: 10px 8px;
    border: none;
    background: none;
    text-align: left;
}

/* Fondo alterno por filas */
.subtabla-centros tbody tr:nth-child(even) {
    background-color: #f5f5f5;
}
.subtabla-centros tbody tr:nth-child(odd) {
    background-color: transparent;
}

/* Columnas: centro amplio, jornadas estrecho, acciones medio */
.subtabla-centros th:nth-child(1),
.subtabla-centros td:nth-child(1) {
    width: 60%;
}

.subtabla-centros th:nth-child(2),
.subtabla-centros td:nth-child(2) {
    width: 10%;
    text-align: center;
}

.subtabla-centros th:nth-child(3),
.subtabla-centros td:nth-child(3) {
    width: 30%;
    text-align: right;
}


.form-agregar-tag {
    width: 500px;
	font-weight: 600;
    margin-top: 100px;
}

.form-agregar-tag select {
    margin-top: 10px;
}

.form-agregar-tag button {
    /* width: 120px !important; */
	margin-right: 30px !important;
	margin-top: 20px;
}

/* Contenedor de botones en cada fila */
.button-container {
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
}

.gestion-usuarios .table-listado td.acciones-grid {
	display: grid;
	grid-template-columns: repeat(4, 91px);
	gap: 5px;
}


/* Organigrama */
.org-chart ul {
  list-style: none;
  padding-left: 20px;
  position: relative;
}

.org-chart ul::before {
  content: '';
  position: absolute;
  top: 0;
  left: 10px;
  border-left: 2px solid #ccc;
  bottom: 0;
}

.org-chart li {
  margin: 10px 0;
  padding-left: 20px;
  position: relative;
}

.org-chart li::before {
  content: '';
  position: absolute;
  top: 10px;
  left: 0;
  width: 10px;
  height: 2px;
  background: #ccc;
}

.nodo-org {
  background: #41b6e6;
  color: white;
  padding: 6px 12px;
  border-radius: 5px;
  font-weight: bold;
  display: inline-block;
}

/* Desplegable Intervenciones */
/* Contenedor principal del select */
.select-orden {
  width: 100%;
}

/* Estilo del control visible */
.select__control {
  min-height: 44px;
  font-size: 15px;
  width: 100%;
  border: 1px solid rgb(187, 187, 187);
  background-color: #e3f1f3; /* como los otros inputs */
}

/* Borde al hacer foco */
.select__control--is-focused {
  border-color: #2699c7;
  box-shadow: 0 0 0 1px #2699c7;
}

/* Texto seleccionado */
.select__single-value {
  white-space: normal;
  font-size: 15px;
}

/* Menú desplegable */
.select__menu {
  z-index: 9999;
}

/* Opciones dentro del menú */
.select__option {
  font-size: 15px;
  padding: 8px 10px;
}


/* Logs */
.logs {
    max-width: 1000px !important;
}


/* Calendario */
.turnos-modal-backdrop {
  position: fixed;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(40,40,70,0.45);
  z-index: 9988;
  display: flex;
  align-items: center;
  justify-content: center;
}
.turnos-modal {
  background: #fff;
  border-radius: 12px;
  padding: 2rem 1.5rem;
  min-width: 340px;
  max-width: 92vw;
  box-shadow: 0 8px 32px rgba(0,0,0,0.16);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
  font-size: 1rem;
}
.turnos-modal label {
  display: block;
  margin-top: 10px;
  color: #222;
  font-weight: 500;
}
.turnos-modal input,
.turnos-modal select {
  margin-top: 6px;
  padding: 0.5em;
  border: 1px solid #aaa;
  border-radius: 6px;
  width: 100%;
  font-size: 1em;
}
.turnos-modal button {
  margin-top: 12px;
  margin-right: 10px;
  padding: 0.4em 1.2em;
  border: none;
  border-radius: 6px;
  background: #3498db;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
}
.turnos-modal button[type="button"] {
  background: #aaa;
}
.turnos-modal button:hover {
  background: #217dbb;
}

/* Altura del área del calendario sin pisar el footer */
.cal-wrapper{
  /* resta cabecera + nav + footer aprox.; ajusta si lo necesitas */
  height: calc(100vh - 220px);
  min-height: 640px;   /* asegura espacio cómodo en pantallas pequeñas */
  padding: 1rem;
}

/* Asegúrate de que el área de contenido pueda hacer scroll si lo necesita */
.layout-content{
  overflow: auto;
}

/* RBC: que la rejilla vertical tenga su propio scroll si hace falta */
.rbc-time-content{
  overflow-y: auto;
}

/* Un pequeño colchón para que no “toque” el borde inferior */
.rbc-time-view{
  padding-bottom: 8px;
}


.alerta {
  background-color: #f8d7da; /* rojo suave */
  color: #721c24;           /* texto rojo oscuro */
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 10px 15px;
  margin: 15px 0;
  text-align: left;
  font-weight: 500;
}

/* Selects React */

/* ========== Anchos unificados para react-select en el formulario manual ========== */
.form-jornada-manual .select-usuario,
.form-jornada-manual .select-cliente,
.form-jornada-manual .select-orden,
.form-jornada-manual .select-centro {
  display: block;   /* react-select usa inline-block por defecto */
  width: 100%;      /* mismo ancho que .input-layout */
}

/* (Opcional) Alinea alturas/estilos del control para que se vea como los inputs */
.form-jornada-manual .select__control {
  min-height: 40px;       /* ajusta si tu .input-layout usa otra altura */
  border-radius: 4px;
}

/* (Opcional) Haz que el menú no recorte dentro de contenedores con overflow */
.form-jornada-manual .select__menu {
  z-index: 5; /* sube si tienes modales o contenedores con z-index alto */
}

/* ========== Anchos unificados para react-select en formulario de iniciar jornada ========== */
.registro-fecha .select-usuario,
.registro-fecha .select-cliente,
.registro-fecha .select-orden,
.registro-fecha .select-centro {
  display: block;
  width: 100%;
}

/* Opcional: alinear alturas/estilos */
.registro-fecha .select__control {
  min-height: 40px;
  border-radius: 4px;
}

.registro-fecha .select__menu {
  z-index: 5;
}

/* === Utilidad reusable para react-select ===
   Úsala añadiendo \`rs-full\` al className del <Select /> */
.rs-full { 
  display: block;
  width: 100%;
}

/* Ajustes del control para que se parezca a .input-layout */
.rs-full.select__control {
  min-height: 40px;
  border-radius: 4px;
}

/* Evita que el menú quede oculto en contenedores con overflow/posicionamiento */
.rs-full.select__menu {
  z-index: 5;
}


/* Media queries */

@media all and (max-width: 1340px) {
    .navbar-nav a{
        font-size: 14px !important;
        padding: 10px 12px !important;
    }
}

@media all and (max-width: 1265px) {


    .navi button {
        margin-bottom: 5px;
        border: 1px solid black;
        background: rgb(55, 165, 210);
    }

    .table-listado-padre {
        max-width: 100%;
        overflow-x: auto;
    }

    .table-listado {
        width: 100%;
    }

    .gestion-usuarios .table-listado {
        /* min-width: auto !important; */
        /* padding-right: 50px !important; */
    }

    .acciones-td {
        white-space: nowrap; /* Evita que los botones se dividan en varias líneas */
        text-align: center;
    }
}

@media all and (max-width: 1190px) {
    .navi a {
        padding-left: 10px;
	}

    .acciones-td {
        /* flex-direction: column; */
        width: 75%;
    }

}

@media all and (max-width: 995px) {
    /* .title-listado {
		margin-left: 20px;
		margin-left: 100px;
	} */

	.table-listado {
        font-size: 14px;
		width: 95%;
		padding: 0px;
	}

    .ticaje-proceso .table-listado {
        width: 100%;
    }

	.th-header-listado {
        font-size: 14px;
	}

	.item-nav {
        padding: 10px 30px !important;
	}
    
}

@media all and (max-width: 941px) {
    .registro-usuarios .modal-form {
        display: grid;
        grid-template-columns: auto 1fr;
    }

    .registro-usuarios .modal-form button {
        grid-column: span 2;
    }

}

@media all and (max-width: 912px) {
    .editar-user .modal-options {
        display: grid;
        grid-template-columns: auto 1fr;
        justify-content: center;
        padding: 0 60px;
    }
}

@media all and (max-width: 831px) {
    .filtros {
        grid-template-columns: repeat(2, auto 1fr);
        grid-template-rows: repeat(2, auto);
        gap: 5px 10px;
    }

        .filtros input, .filtros select {
            margin-right: 5px;
        }
}

@media all and (max-width: 758px) {
    .exportar-botones {
        flex-wrap: wrap;
    }

        .exportar-botones button {
            font-size: 10px;
        }
}

@media all and (max-width: 744px) {
    .exportar-botones {
        width: 100%;
        grid-template-columns: repeat(2,1fr);
        gap: 10px 20px;
    }
}

@media all and (max-width: 731px) {

    .form-agregar-cliente {
        display: flex;
        flex-direction: column;
    }

    .tabla-clientes {
        display: flex;
        flex-direction: column;
    }

    .acciones-td {
        flex-direction: column;
        max-width: 90%;
        width: 100%;
    }
    .tabla-clientes .table-listado-padre {
        width: 90%;
    }

    .modal-content {
        width: 100% !important;
    }
}

@media all and (max-width: 676px) {
    
    .registro-fecha {
		width: 400px;
		font-size: 14px;
	}
}

@media all and (max-width: 550px) {
    .filtros {
        grid-template-columns: auto 1fr;
    }
}


@media all and (max-width:521px) {
    .ticaje-proceso .table-listado td, 
    .ticaje-proceso .table-listado th {
        width: 24%;
    }
}

@media all and (max-width: 500px) {
    
    .registro-fecha {
        width: 340px;
		/* font-size: 14px; */
	}
    
	.form-tag {
        width: 300px !important;
		margin-left: 30px;
	}
    
	.form-tag input {
        width: 90%;
        
	}

    .modal-content {
        padding: 0px;
    }

    .registro-usuarios .modal-form {
        padding: 10px;
    }

    .registro-usuarios .modal-form * {
        margin: 0;
    }

    .registro-usuarios .modal-form button {
        margin: 0;
    }

    .modal-content h3 {
        margin: 20px;
    }

    .modal-centro input{
        height: 25px;
    }
    
    .modal-content label {
        margin-left: 20px;
    }

    .modal-content button {
        margin: 0 0 20px 20px;
    }

    .modal-options button,
    .editar-user button {
        margin: 0;
    }

    .modal-options label {
        margin: 0;
    }

    .listado-container .modal-content {
        padding: 10px;
    }

    .listado-container .modal-content .btn-login {
        margin-left: 0;
    }
}

@media all and (max-width: 482px) {
    .formulario-usuario {
        grid-template-columns: 1fr;
    }

    .formulario-usuario .form-group {
        flex-direction: column;
    }
    .formulario-usuario .form-group select {
        max-width: 100%;
    }
    .formulario-usuario .btn-login {
        max-width: 100%;
    }
}

@media all and (max-width: 445px) {

    .modal-content {
        width: 100% !important;
        /* height: 92% !important; */
    }

    .leaflet-container {
        height: 250px !important;
    }
    
    .reset {
        width: 50px !important;
    }
    .glass {
        min-width: 50% !important;
        width: 50% !important;
    }
}

@media all and (max-width: 428px) {

    h2.centrar-titulo {
        margin-left: 20px;
    }

    .formulario-ticaje {
        width: 100%;
    }

    .form-orden {
        width: 100%;
    }

        .form-orden h2 {
            width: 95%;
            margin: 0 auto;
        }

    .registro-fecha {
        margin-top: 60px !important;
        width: 100%;
    }

    .ticaje-proceso {
        width: 100%;
    }

        .ticaje-proceso p {
            margin-left: 30px;
        }

    .table-listado {
        font-size: 14px;
        /* margin:0 auto; */
    }

    .form-agregar-cliente input {
        height: 35px;
        width: 155px;
        font-size: 12px;
    }
    .form-agregar-cliente button {
        font-size: 12px;
        height: 35px;
        padding: 0 15px;
    }

    .editar-user button:last-child {
        width: 50%;
        margin: 0 auto 20px;
    }

    .editar-user .modal-options {
        padding: 0 10px;
    }
    
}

@media all and (max-width: 401px) {
    .layout_identificarse {
        width: 100%;
        margin: 0;
    }

    .layout {
        grid-template-rows: 100px 70px 1fr 100px;
    }
    .footer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        line-height: 30px;   
    }
}

@media all and (max-width: 378px) {
    .form-agregar-tag {
        margin: 50px 0;
    }
}

@media all and (max-width: 360px) {
    .layout_identificarse {
        width: 100%;
    }

    .consulta-ticajes .filtros {
        grid-template-columns: 1fr;
    }

    .cambiar-contrasena form {
        grid-template-columns: 1fr !important;
    }

    .cambiar-contrasena .form-group {
        grid-column: 1;
    }
}

@media all and (max-width: 347px) {
    .listado-container .modal-content .checkbox-group {
        grid-template-columns: 1fr;
    }
}


/* Cementerio de clases */

/* .nav {
    background-color: #41b6e6;
} */

/* .nav ul {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
} */

/* .nav a {
    display: block;
    margin-left: 30px;
    margin-right: 30px;
    color: white;
    text-decoration: none;
    font-size: 18px;
    font-weight: bold;
    transition: all 300ms;
}

.nav a:hover {
    transform: scale(1.3, 1.3)
} */

.nav-dropdown .dropdown-menu {
    background-color: #41b6e6;
    color: white;
} 
.nav-dropdown:hover {
    display: block;
}


.custom-nav-dropdown .dropdown-item {
    background-color: #41b6e6;
    color: black;
}

/* .sub-menu {
    padding: 0px !important;
} */

/* .block {
    background: #9de3ff !important;   
}

.block:hover {
    cursor: default !important;
    background: #9de3ff !important;
} */
            
/* .mr-auto {
    min-height: 15px;
    background-color: #41b6e6;

} */

/* .content-ajustes {
	margin: 20px 100px;
	display: flex;
	justify-content: start;
} */

/* .marco-mapa {
    height: 700px;
    width: 100%;
    align-items: center;
} */

/* .leaflet-container {
    display: block;
	width: 100%;
	min-width: 600px;
} */

/* .butt{
    background-color: #41b6e6;
    color: white;
    border: 0;
    outline: 0;
  padding: 15px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 300ms;
  
} */

/* form {
	padding: 10px;
	margin: 5px;
	margin-left: 15px;
	display: block;
	justify-content: center;
	align-items: center;
	padding: 15px;
} */

/* form button,
form input[type="submit"],
form input[type="button"] {
	background-color: #41b6e6;
	color: white;
	border: 0;
	outline: 0;
	padding: 8px 15px;
	border-radius: 5px;
	margin-top: 15px;
	margin: 15px;
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	transition: all 300ms;
} */

/* .paginador button,
.paginador form input[type="submit"],
.paginador form input[type="button"] {
    background-color: #41b6e6;
	color: white;
	border: 0;
	outline: 0;
	padding: 15px;
	border-radius: 5px;
	margin-top: 15px;
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	transition: all 300ms;
}

.paginador>* {
	margin: 0 10px;
    
} */


/* .layout_identificarse h2 {
	margin-bottom: 20px;
	color: #41b6e6;
} */

/* .label-layout {
    text-align: start;
} */

/* button .navbar-toggle:focus {
    border: 0px;
	;
} */

/* app/listadotrabajos */
/* .input-mostrar {
    margin-top: -10px;
} */

/* .title-listado {
	margin-left: 300px;
	margin-bottom: 35px;
	text-transform: uppercase;
	letter-spacing: 1.5px;
} */

/*app/listamatricula */
/* .lista-matricula-content {
    display: flex;
	background: red;
} */

/* .matricula-form {
    display: flex;
	flex-flow: wrap row;
	background: rgb(213, 219, 220);
	width: 350px;
	margin-bottom: 30px;
	font-weight: 600;
	font-size: 18px;
	margin: 0px auto;
	margin-bottom: 20px;
} */

/* .matricula-form label {
	flex: 1 100%;
	margin-bottom: 10px;
	margin-left: 30px;
} */

/* .buscar-listado {
    display: flex;
	width: auto;
	justify-self: end;
} */

/* .btn-fecha {
    justify-self: center;
} */

/* .mostrar-todos {
    grid-row: 2/3;
	width: 150px;
} */

/* .listado-clientes ul {
    list-style-type: none;
	padding: 0;
} */

/* .cliente-item {
	margin-bottom: 20px;
	padding: 10px;
	border: 1px solid #ddd;
	border-radius: 5px;
} */

/* .cliente-header {
    display: flex;
	justify-content: space-between;
	align-items: center;
} */

/* .btn-expand {
    background-color: #41b6e6;
	color: white;
	border: none;
	padding: 5px 10px;
	border-radius: 5px;
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.btn-expand:hover {
    background-color: #2699c7;
} */

/* .lugares-list {
    margin-top: 10px;
	padding-left: 20px;
} */

/* .lugar-item {
    margin-bottom: 5px;
} */

/* .btn-atras:hover,
input[type="submit"]:hover,
button[type="submit"]:hover {
    background: #3f92ca !important;
}

.btn-atras {
    margin-top: 0px !important;
    
} */

/* .paginador {
    margin: 15px;
	margin-left: 15px;
	;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 15px;
} */

/* .num-pag,
.pag-previus,
.pag-next {
    background: rgb(238, 238, 238) !important;
	color: black !important;
} */

/* .num-pag {
    padding: 5px 10px !important;
	height: 33px !important;
	border-radius: 0px !important;
	margin-top: 0px !important;
	margin-right: 5px !important;
	margin-left: 0px !important;
    
} */

/* .num-pag:hover {
    background: rgb(193, 193, 193) !important;
} */

/* ico-pag {
    font-size: 16px !important;
} */

/* .pag-previus,
.pag-next {
    height: 33px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0px !important;
	margin-right: 5px !important;
} */

/* .pag-next:hover,
.pag-previus:hover {
    background: rgb(193, 193, 193) !important;
} */

/* .lateral {
	min-width: 200px;
} */

/* app/listaportag */
/* .form-tag {
    width: 450px;
	font-weight: 600;
} */

/* .form-tag input {
    grid-column: 1/2;
} */

/* app/formtags */
/* .tr-body-tags td {
    padding-left: 15px !important;
	padding: 10px;
} */

/* .button-delete {
    background: transparent !important;
	color: rgb(0, 0, 0) !important;
	display: flex;
	align-items: center;
	font-size: 20px !important;
    
} */

/* .ico-modificar {
    color: black;
	font-size: 20px;
} */

/* .ico-delete {
    transition: all 300ms ease;
} */

/* .ico-delete:hover,
.ico-modificar:hover {
    color: rgb(83, 83, 83) !important;
} */

/* .btn-atras,
input[type="submit"] {
    width: 50%;
	justify-self: end;
} */

/* Botones */
/* .btn-mostrar-lugares {
    background: #41b6e6;
	color: white;
	border: none;
	padding: 8px 10px;
	border-radius: 4px;
	cursor: pointer;
} */

/* .btn-agregar-centro {
	background: #28a745;
	color: white;
} */

/* .btn-eliminar-cliente,
.btn-eliminar-centro {
    background: #dc3545;
	color: white;
} */

/* Separar clientes de sus centros */
/* .lugar-row td {
    padding-left: 40px !important;
	background: #eeeeee;
} */

/* .icon-mostrar {
    background: transparent !important;
	color: rgb(0, 0, 0) !important;
	font-size: 20px !important;
} */

/* .perido {
    flex: 1 1 50% !important;
} */

/* .closeButton {
    position: absolute;
	top: 10px;
	right: 10px;
	border: none;
	cursor: pointer;
	font-size: 16px;
	background: white;
	color: black;
} */

/* .open-button {
    padding: 10px 20px;
	background-color: #007bff;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
} */

/* .open-button:hover {
    background-color: #0056b3;
} */

/* Ajustes */


/* .perfil h2 {
	width: 80%;
	margin-bottom: 20px;
} */

/* .contraseña h4 {
    text-align: center;
} */

/* .formulario-contraseña {
    display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: 1fr auto;
	gap: 15px;
}

.form-contraseña.label {
    grid-column: 1/2;
	grid-row: 1/2;
	text-align: end;
}

.form-contraseña.label label {
	margin-bottom: 10px;
}

.form-contraseña.input {
    grid-column: 2/3;
	grid-row: 1/2;
}

.input-guardar {
    grid-column: 2/3;
	grid-row: 2/3;
}

.input-guardar input[type='submit'] {
	margin: 0;
}

.form-contraseña.input input {
    margin-bottom: 10px;
} */



/* @media all and (max-width: 944px) {
    .crea-form {
		width: 280px;
		font-size: 14px;
		margin: 0px 40px 40px 40px;
	}
    
	.crea-form button {
        font-size: 14px;
	}
} */`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,uCAAuC;CACvC,mCAAmC;CACnC,gCAAgC;CAChC,oCAAoC;CACpC,cAAc;CACd,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;;AAEA,qBAAqB;;AAErB;CACC,YAAY;IACT,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;CAC1B,iBAAiB;AAClB;;AAEA;;;;IAII,iBAAiB;CACpB,yBAAyB;CACzB,YAAY;CACZ,SAAS;CACT,6BAA6B;CAC7B,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,eAAe;;CAEf,uBAAuB;CACvB,sBAAsB;;CAEtB,qBAAqB;;;IAGlB;;;;MAIE;AACN;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,UAAU,YAAY,6BAA6B;EACnD,iBAAiB,KAAK,6BAA6B;EACnD,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;;;AAIA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB,EAAE,oBAAoB;EACxC,WAAW;AACb;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB,EAAE,sCAAsC;EACxD,gBAAgB;EAChB,WAAW;AACb;;;AAGA;;;EAGE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;CACC,kBAAkB;AACnB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;CACvC,oBAAoB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,4BAA4B;CAC/B,YAAY;CACZ,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,yCAAyC;AAC1C;AACA,WAAW;;AAEX;CACC,WAAW;CACX,iBAAiB;CACjB,aAAa;CACb;;;;+BAI8B;CAC9B,uCAAuC;;CAEvC,mBAAmB;CACnB,qCAAqC;AACtC;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;;CAEhB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,iBAAiB;CACjB,oBAAoB;CACpB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,wBAAwB;CACxB,wCAAwC;CACxC,uBAAuB;;AAExB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,YAAY;CACZ,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,6BAA6B;CAC7B,qBAAqB;AACtB;;;AAGA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;CACnB,2BAA2B;CAC3B,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;;;AAGA,WAAW;AACX;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB,IAAI,+BAA+B;EACzD,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY,cAAc,4CAA4C;EACtE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,eAAe,KAAK,oBAAoB;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;;AAGA,kBAAkB;AAClB;CACC,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,6BAA6B;CAC7B,mBAAmB;AACpB;;AAEA,4BAA4B;;AAE5B;IACI,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;IAEI;QACI,WAAW;QACX,iBAAiB;IACrB;;AAEJ;;IAEI,uBAAuB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;AACA,iBAAiB,iBAAiB,EAAE;;AAEpC,eAAe;AACf;EACE,UAAU;EACV,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,qBAAqB,gBAAgB,EAAE,kBAAkB,EAAE;AAC3D;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW,UAAU,iCAAiC;EACtD,gBAAgB,KAAK,uBAAuB;AAC9C;;AAEA,8BAA8B,aAAa,EAAE;AAC7C,6BAA6B;AAC7B,8BAA8B,aAAa,EAAE;AAC7C,sCAAsC,gBAAgB,EAAE;;AAExD,aAAa;AACb,iCAAiC,aAAa,EAAE,QAAQ,EAAE;AAC1D,4BAA4B,gBAAgB,EAAE;AAC9C,+BAA+B,YAAY,EAAE;AAC7C,+BAA+B,UAAU,EAAE;AAC3C,kCAAkC,WAAW,EAAE,gBAAgB,EAAE;;AAEjE,6DAA6D;AAC7D,mCAAmC,YAAY,EAAE,QAAQ,6BAA6B;AACtF;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe,gBAAgB,+CAA+C;AAChF;AACA;EACE,WAAW,oBAAoB,8BAA8B;EAC7D,gBAAgB;EAChB,mBAAmB,YAAY,gCAAgC;AACjE;AACA,2CAA2C,WAAW,EAAE;;AAExD,uDAAuD;AACvD,mCAAmC,mBAAmB,EAAE;AACxD;sCACsC,gBAAgB,EAAE,uBAAuB,EAAE;;;AAGjF,mBAAmB;;AAEnB;IACI,UAAU;AACd;;AAEA;CACC,8BAA8B;;IAE3B,gBAAgB;CACnB,iBAAiB;CACjB,aAAa;;CAEb,aAAa;CACb,sBAAsB;CACtB,uBAAuB;;CAEvB,kBAAkB;CAClB,eAAe;AAChB;;CAEC;EACC,gBAAgB;;CAEjB;;CAEA;EACC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;CACnB;;;CAGA;EACC,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;CAC9B;;EAEC;GACC,cAAc;GACd,mBAAmB;EACpB;;EAEA;GACC,WAAW;EACZ;;EAEA;GACC,WAAW;GACX,gBAAgB;EACjB;;KAEG;YACO,yBAAyB;YACzB,oBAAoB;YACpB,WAAW;KAClB;;CAEJ;EACC,wCAAwC;CACzC;;CAEA,sBAAsB;AACvB;IACI,UAAU;;CAEb,gBAAgB;;CAEhB,aAAa;CACb,sBAAsB;CACtB,uBAAuB;AACxB;;;AAGA;CACC,mBAAmB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D,+BAA+B,YAAY,EAAE,sBAAsB,EAAE;AACrE,kCAAkC,YAAY,EAAE,sBAAsB,EAAE;;AAExE,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,UAAU,gBAAgB,EAAE;AAC5B,aAAa,cAAc,EAAE,IAAI,UAAU;AAC3C,aAAa,cAAc,EAAE,IAAI,SAAS;AAC1C,gBAAgB,WAAW,EAAE,gBAAgB,EAAE;;AAE/C,kDAAkD;AAClD;;EAEE,sBAAsB;AACxB;;AAEA,sDAAsD;AACtD;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ,kBAAkB,mDAAmD;EAC7E,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe,SAAS,uBAAuB;EAC/C,gBAAgB,QAAQ,+BAA+B;EACvD,cAAc,UAAU,sCAAsC;EAC9D,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC,IAAI,4BAA4B;EACjE,oBAAoB,iBAAiB,sCAAsC;EAC3E,eAAe,sBAAsB,+BAA+B;EACpE,gBAAgB,qBAAqB,8BAA8B;EACnE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;;EAE1B,0CAA0C;EAC1C,6BAA6B;EAC7B,+BAA+B;;EAE/B,gBAAgB,QAAQ,uCAAuC;EAC/D,cAAc;AAChB;;AAEA;kEACkE;AAClE;EACE,cAAc,EAAE,0CAA0C;AAC5D;AACA;EACE,cAAc,EAAE,yCAAyC;AAC3D;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,UAAU;EACV,gBAAgB,EAAE,+CAA+C;AACnE;;AAEA,+DAA+D;AAC/D;EACE;IACE,QAAQ;IACR,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;;EAEE,SAAS,kBAAkB,wBAAwB;EACnD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,uBAAuB,IAAI,8BAA8B;EACzD,8BAA8B,IAAI,+CAA+C;EACjF,SAAS,kBAAkB,oBAAoB;AACjD;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,+DAA+D;EAC/D,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,YAAY,iCAAiC;EACrD,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;;AAGA,0CAA0C;AAC1C,aAAa,eAAe,EAAE;AAC9B,mBAAmB,0BAA0B,EAAE;;AAE/C;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,oDAAoD;AACpD;EACE,eAAe;EACf,iBAAiB;AACnB;;;AAGA,oBAAoB;AACpB;IACI,UAAU;IACV,YAAY;AAChB;;IAEI;QACI,gBAAgB;QAChB,iBAAiB;;QAEjB,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;IACA;QACI,mBAAmB;IACvB;;AAEJ,oBAAoB;;AAEpB;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,qCAAqC;AACzC;;;AAGA,qBAAqB;;AAErB;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;CAEC;EACC,mBAAmB;CACpB;;CAEA;EACC,UAAU;QACJ,YAAY;CACnB;;EAEC;GACC,WAAW;YACF,iBAAiB;YACjB,iBAAiB;YACjB,gBAAgB;EAC1B;;GAEC;gBACa,UAAU;gBACV,iBAAiB;IAC7B,YAAY;GACb;GACA;gBACa,YAAY;gBACZ,2BAA2B;GACxC;;IAEC;QACI,gBAAgB;QAChB,qCAAqC;IACzC;;;;CAIH;EACC,gBAAgB;EAChB,UAAU;QACJ,YAAY;CACnB;;QAEO;YACI,kBAAkB;YAClB,YAAY;QAChB;;QAEA;YACI,WAAW;YACX,uBAAuB;YACvB,YAAY;YACZ,gBAAgB;YAChB,kBAAkB;YAClB,kBAAkB;YAClB,yBAAyB;EACnC;QACM;;YAEI,uBAAuB;YACvB,2BAA2B;QAC/B;;;QAGA;YACI,aAAa;YACb,YAAY;YACZ,QAAQ;YACR,sBAAsB;QAC1B;QACA;YACI,YAAY;QAChB;;QAEA;YACI,gBAAgB;QACpB;;EAEN;GACC,kBAAkB;EACnB;;QAEM;;YAEI,YAAY;QAChB;QACA;;YAEI,YAAY;QAChB;QACA;;YAEI,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;;AAGR,eAAe;;AAEf,wDAAwD;AACxD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;;;;EAIE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,mBAAmB,EAAE,oCAAoC;EACzD,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB,UAAU,uCAAuC;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;;AAGA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB,OAAO,qCAAqC;EAC7D,mBAAmB,KAAK,iCAAiC;AAC3D;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,4CAA4C;EAC5C,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,2BAA2B,EAAE,eAAe;AAC9C;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;;;;;EAQE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe,YAAY,0CAA0C;EACrE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;EACX,mBAAmB,QAAQ,yCAAyC;AACtE;;;AAGA,8DAA8D;AAC9D;EACE,WAAW;AACb;;AAEA,6CAA6C;AAC7C;;EAEE,UAAU,IAAI,WAAW;AAC3B;;AAEA;;EAEE,UAAU,IAAI,cAAc;AAC9B;;AAEA;;EAEE,UAAU,IAAI,kBAAkB;AAClC;;AAEA;;;;EAIE,UAAU,IAAI,WAAW;AAC3B;;AAEA,kDAAkD;AAClD;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,yEAAyE;AACzE;EACE,sBAAsB;EACtB,6BAA6B,IAAI,uBAAuB;EACxD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB,IAAI,mBAAmB;EAC1C,cAAc,SAAS,gBAAgB;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,QAAQ,yBAAyB,mCAAmC;EACpE,4BAA4B;EAC5B,eAAe,kBAAkB,4BAA4B;EAC7D,aAAa;EACb,uBAAuB;EACvB,uBAAuB,UAAU,sCAAsC;EACvE,gBAAgB,iBAAiB,4CAA4C;EAC7E,kBAAkB,eAAe,2CAA2C;AAC9E;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB,iBAAiB,kCAAkC;AACrE;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc,mBAAmB,qCAAqC;AACxE;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;;AAGA,eAAe;;AAEf;;2BAE2B;;AAE3B,8BAA8B;AAC9B;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,YAAY,iBAAiB,EAAE;AAC/B,iBAAiB,gBAAgB,EAAE;AACnC,SAAS,YAAY,EAAE;AACvB,QAAQ,cAAc,EAAE;;AAExB,YAAY;AACZ;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB,SAAS,WAAW;AACtC;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;AACb;;AAEA,mBAAmB,iBAAiB,EAAE,uCAAuC,EAAE;;;;AAI/E,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,SAAS,EAAE,qBAAqB;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;AACf;;AAEA,oBAAoB,gBAAgB,EAAE,eAAe,EAAE;AACvD,iBAAiB,eAAe,EAAE,eAAe,EAAE;AACnD,sBAAsB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAElF;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B,IAAI,aAAa;EAC5C,QAAQ,uBAAuB,uBAAuB;AACxD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB,IAAI,+BAA+B;EACpD,gBAAgB,KAAK,6CAA6C;AACpE;;;AAGA,gBAAgB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;;AAE9D,oCAAoC;AACpC;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB,mBAAmB;AACnB;EACE,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,aAAa;AACb,iBAAiB,YAAY,EAAE;;AAE/B;EACE,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;EAC1B,OAAO;AACT;;AAEA,kBAAkB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACrE,mBAAmB,cAAc,EAAE,UAAU,EAAE;AAC/C,yBAAyB,UAAU,EAAE;;AAErC;EACE,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;;AAGA;;2BAE2B;;AAE3B;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,2BAA2B;EAC3B,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;2BAE2B;;AAE3B;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;;AAGA,wBAAwB;AACxB;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;AACxB;;CAEC;EACC,UAAU;QACJ,YAAY;CACnB;;EAEC;GACC,mBAAmB;YACV,iBAAiB;EAC3B;;QAEM;YACI,YAAY;YACZ,eAAe;YACf,0BAA0B;QAC9B;;QAEA;YACI,yBAAyB;;QAE7B;;EAEN;GACC,WAAW;YACF,eAAe;YACf,mBAAmB;EAC7B;;QAEM;YACI,gBAAgB;YAChB,qBAAqB;YACrB,gBAAgB;YAChB,WAAW;QACf;;YAEI;gBACI,eAAe;gBACf,iBAAiB;gBACjB,kBAAkB;gBAClB,kBAAkB;gBAClB,yBAAyB;YAC7B;;YAEA;;;;;;;;;;;;;;eAcG;;YAEH;;gBAEI,mBAAmB;YACvB;;YAEA;gBACI,iBAAiB;gBACjB,gBAAgB;gBAChB,WAAW;YACf;;QAEJ;YACI,WAAW;YACX,aAAa;YACb,oBAAoB;QACxB;QACA;YACI,gBAAgB;YAChB,aAAa;YACb,sCAAsC;YACtC,0BAA0B;YAC1B,mBAAmB;YACnB,SAAS;YACT,eAAe;QACnB;QACA;YACI,eAAe;YACf,WAAW;QACf;;;CAGP;EACC,UAAU;EACV,gBAAgB;EAChB,mBAAmB;CACpB;;EAEC;GACC,eAAe;EAChB;;EAEA;GACC,gBAAgB;GAChB,gBAAgB;EACjB;;;AAGF,mBAAmB;AACnB;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,aAAa;;IAEb,aAAa;IACb,qCAAqC;;IAErC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA,2DAA2D;;AAE3D,sCAAsC;AACtC;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;AACV;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY,aAAa,gCAAgC;EACzD,eAAe;EACf,kBAAkB;EAClB,mBAAmB,MAAM,gDAAgD;EACzE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,UAAU,EAAE,WAAW;EACvB,UAAU,EAAE,YAAY;EACxB,gBAAgB,EAAE,mBAAmB;EACrC,mBAAmB,EAAE,SAAS;AAChC;;AAEA,6CAA6C;AAC7C;;;;EAIE,YAAY,aAAa,4CAA4C;AACvE;;AAEA,8CAA8C;AAC9C;EACE,qBAAqB,QAAQ,EAAE;EAC/B,WAAW,YAAY,EAAE,eAAe,EAAE,cAAc,EAAE;AAC5D;;;AAGA,qBAAqB;AACrB;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;IAEI;QACI,UAAU;QACV,iBAAiB;QACjB,SAAS;;IAEb;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,cAAc;IAClB;;QAEI;YACI,WAAW;QACf;;;QAGA,4BAA4B;YACxB;gBACI,aAAa;gBACb,0CAA0C;YAC9C;;YAEA;gBACI,mBAAmB;gBACnB,sBAAsB;YAC1B;;;;IAIR;QACI,UAAU;QACV,YAAY;IAChB;;QAEI;YACI,gBAAgB;QACpB;;QAEA;YACI,2BAA2B;QAC/B;;YAEI;;gBAEI,cAAc;;gBAEd,aAAa;gBACb,uBAAuB;gBACvB,mBAAmB;gBACnB,SAAS;YACb;;YAEA;gBACI,UAAU;gBACV,gBAAgB;gBAChB,YAAY;gBACZ,kBAAkB;YACtB;;IAER;QACI,UAAU;QACV,+BAA+B;QAC/B,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;QAC5B,4BAA4B;;IAEhC;;IAEA;IACA,YAAY,EAAE,QAAQ;IACtB;IACA;IACA,YAAY,EAAE,WAAW;IACzB;IACA;IACA,YAAY,EAAE,cAAc;IAC5B;IACA;IACA,YAAY,EAAE,UAAU;IACxB;IACA;IACA,YAAY,EAAE,aAAa;IAC3B;IACA;IACA,YAAY,EAAE,QAAQ;IACtB;IACA;IACA,YAAY,EAAE,YAAY;IAC1B;IACA;IACA,gBAAgB,EAAE,aAAa;IAC/B;;;IAGA;QACI,aAAa;QACb,sCAAsC;QACtC,QAAQ;QACR,8BAA8B;IAClC;IACA;QACI,WAAW;IACf;;QAEI;YACI,WAAW;QACf;;QAEA,uCAAuC;QACvC;YACI,WAAW;YACX,iBAAiB;YACjB,eAAe;YACf,kBAAkB;YAClB,2BAA2B;QAC/B;;QAEA;YACI,YAAY;YACZ,0BAA0B;QAC9B;;QAEA;YACI,yBAAyB;QAC7B;;AAER;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,kCAAkC;IAC9B;IACA,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,aAAa;;IAEb,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;IACb;;IAEA;IACA,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;;IAEA;IACA,aAAa;IACb,sBAAsB;IACtB;;IAEA;IACA,mBAAmB;IACnB;;IAEA;IACA,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB;;AAEJ,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,wEAAwE;AACxE;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;;AAGA,sBAAsB;AACtB;EACE,eAAe;EACf,SAAS,EAAE,SAAS;EACpB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,+BAA+B;AACjC;AACA,eAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC/E,eAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC/E,eAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAE/E,qBAAqB,OAAO,UAAU,EAAE,gCAAgC,EAAE,EAAE,KAAK,UAAU,EAAE,6BAA6B,EAAE,EAAE;;AAE9H,kCAAkC;AAClC;EACE,+BAA+B;AACjC;AACA,oBAAoB,OAAO,UAAU,EAAE,0BAA0B,CAAC,EAAE,KAAK,UAAU,EAAE,wBAAwB,CAAC,EAAE;;AAEhH,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB,WAAW,uCAAuC;EACpE,gBAAgB,aAAa,4BAA4B;EACzD,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;;;AAIA,2CAA2C;AAC3C;EACE,4BAA4B,OAAO,qBAAqB;EACxD,iCAAiC;EACjC,mBAAmB,gBAAgB,6CAA6C;EAChF,gBAAgB,mBAAmB,4BAA4B;AACjE;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB,kBAAkB,uBAAuB;EAC1D,QAAQ,2BAA2B,6CAA6C;EAChF,YAAY,uBAAuB,qCAAqC;AAC1E;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS,0BAA0B,iCAAiC;EACpE,sBAAsB;EACtB,sBAAsB,aAAa,gCAAgC;EACnE,mBAAmB,gBAAgB,uCAAuC;EAC1E,cAAc,qBAAqB,kCAAkC;EACrE,iBAAiB,kBAAkB,iCAAiC;AACtE;;AAEA,8DAA8D;AAC9D;;;;EAIE,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;;EAEE,6BAA6B,EAAE,4BAA4B;AAC7D;;;;;AAKA,YAAY;AACZ;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;IAEI;QACI,WAAW;QACX,gBAAgB;IACpB;;QAEI;YACI,mBAAmB;QACvB;;QAEA;YACI,8BAA8B;YAC9B,gBAAgB;YAChB,aAAa;;YAEb,aAAa;YACb,8BAA8B;YAC9B,WAAW;QACf;;YAEI;gBACI,mBAAmB;;gBAEnB,aAAa;gBACb,8BAA8B;gBAC9B,mBAAmB;gBACnB,2BAA2B;;YAE/B;;QAEJ;YACI,mBAAmB;YACnB,WAAW;;QAEf;;;AAGR,UAAU;AACV;CACC,8BAA8B;CAC9B,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;;CAEb,aAAa;IACV,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;;AAEjC;;IAEI;KACC,cAAc;QACX,gBAAgB;QAChB,mBAAmB;IACvB;;QAEI;YACI,aAAa;YACb,kCAAkC;YAClC,sBAAsB;QAC1B;;QAEA;YACI,cAAc;QAClB;;YAEI;gBACI,kBAAkB;YACtB;;;AAGZ,UAAU;AACV;IACI,eAAe;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,+CAA+C;CAC/C,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;IAEI;QACI,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,kCAAkC;QAClC,qBAAqB;QACrB,uBAAuB;QACvB,gCAAgC;QAChC,aAAa;QACb,kBAAkB;QAClB,sCAAsC;QACtC,2BAA2B;;QAE3B,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;QACI;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;YAEI;gBACI,aAAa;gBACb,SAAS;YACb;;YAEA;gBACI,YAAY;YAChB;;YAEA;gBACI,YAAY;YAChB;;;;;;;;;AASZ,uBAAuB;AACvB;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;CACnB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,8BAA8B;CAC9B,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;IACI,mBAAmB;CACtB,8BAA8B;CAC9B,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;IACI,4BAA4B;CAC/B,eAAe;CACf,WAAW;CACX,yBAAyB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;;;;;AAMA;IACI,YAAY;CACf,mBAAmB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;CACnB,mBAAmB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;CACC,mBAAmB;CACnB,eAAe;IACZ,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,eAAe;CAClB,8BAA8B;AAC/B;;AAEA;IACI,aAAa;CAChB,2CAA2C;AAC5C;;AAEA,8BAA8B;AAC9B;IACI,mBAAmB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA,sCAAsC;AACtC;IACI,mBAAmB;CACtB,mBAAmB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,6BAA6B;AACjC;;AAEA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,yBAAyB;AAC7B;AACA;IACI,6BAA6B;AACjC;;AAEA,+DAA+D;AAC/D;;IAEI,UAAU;AACd;;AAEA;;IAEI,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,iBAAiB;AACrB;;;AAGA;IACI,YAAY;CACf,gBAAgB;IACb,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;CAChC,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA,uCAAuC;AACvC;CACC,aAAa;CACb,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,sCAAsC;CACtC,QAAQ;AACT;;;AAGA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B,oCAAoC;AACpC;EACE,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,iBAAiB;AACnB;;;AAGA,SAAS;AACT;IACI,4BAA4B;AAChC;;;AAGA,eAAe;AACf;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,iEAAiE;EACjE,2BAA2B;EAC3B,iBAAiB,IAAI,iDAAiD;EACtE,aAAa;AACf;;AAEA,4EAA4E;AAC5E;EACE,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB,EAAE,eAAe;EAC1C,cAAc,YAAY,sBAAsB;EAChD,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB;;AAElB,sFAAsF;AACtF;;;;EAIE,cAAc,IAAI,8CAA8C;EAChE,WAAW,OAAO,kCAAkC;AACtD;;AAEA,kFAAkF;AAClF;EACE,gBAAgB,QAAQ,+CAA+C;EACvE,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE,UAAU,EAAE,2DAA2D;AACzE;;AAEA,+FAA+F;AAC/F;;;;EAIE,cAAc;EACd,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;0DAC0D;AAC1D;EACE,cAAc;EACd,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,UAAU;AACZ;;;AAGA,kBAAkB;;AAElB;IACI;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;AACJ;;AAEA;;;IAGI;QACI,kBAAkB;QAClB,uBAAuB;QACvB,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gCAAgC;QAChC,oCAAoC;IACxC;;IAEA;QACI,mBAAmB,EAAE,sDAAsD;QAC3E,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;CACzB;;IAEG;QACI,4BAA4B;QAC5B,UAAU;IACd;;AAEJ;;AAEA;IACI;;;IAGA;;CAEH;QACO,eAAe;EACrB,UAAU;EACV,YAAY;CACb;;IAEG;QACI,WAAW;IACf;;CAEH;QACO,eAAe;CACtB;;CAEA;QACO,6BAA6B;CACpC;;AAED;;AAEA;IACI;QACI,aAAa;QACb,+BAA+B;IACnC;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;;AAEA;IACI;QACI,aAAa;QACb,+BAA+B;QAC/B,uBAAuB;QACvB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0CAA0C;QAC1C,mCAAmC;QACnC,aAAa;IACjB;;QAEI;YACI,iBAAiB;QACrB;AACR;;AAEA;IACI;QACI,eAAe;IACnB;;QAEI;YACI,eAAe;QACnB;AACR;;AAEA;IACI;QACI,WAAW;QACX,oCAAoC;QACpC,cAAc;IAClB;AACJ;;AAEA;;IAEI;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,cAAc;QACd,WAAW;IACf;IACA;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;;IAEI;EACF,YAAY;EACZ,eAAe;CAChB;AACD;;AAEA;IACI;QACI,+BAA+B;IACnC;AACJ;;;AAGA;IACI;;QAEI,UAAU;IACd;AACJ;;AAEA;;IAEI;QACI,YAAY;EAClB,qBAAqB;CACtB;;CAEA;QACO,uBAAuB;EAC7B,iBAAiB;CAClB;;CAEA;QACO,UAAU;;CAEjB;;IAEG;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;IAC1B;IACA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;AACJ;;AAEA;;IAEI;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;QAEI;YACI,UAAU;YACV,cAAc;QAClB;;IAEJ;QACI,2BAA2B;QAC3B,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;QAEI;YACI,iBAAiB;QACrB;;IAEJ;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;IACA;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,wCAAwC;IAC5C;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;;AAGA,yBAAyB;;AAEzB;;GAEG;;AAEH;;;;;GAKG;;AAEH;;;;;;;;;;;;;GAaG;;AAEH;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,cAAc;AAClB;;;AAGA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;GAEG;;AAEH;;;;;;;GAOG;;AAEH;;;;GAIG;;AAEH;;;;GAIG;;AAEH;;;;GAIG;;AAEH;;;;GAIG;;AAEH;;;;;;;;;;;;GAYG;;AAEH;;;;;;;;GAQG;;AAEH;;;;;;;;;;;;;;;GAeG;;AAEH;;;;;;;;;;;;;;;;;;;GAmBG;;;AAGH;;;GAGG;;AAEH;;GAEG;;AAEH;;;GAGG;;AAEH,wBAAwB;AACxB;;GAEG;;AAEH;;;;;GAKG;;AAEH,sBAAsB;AACtB;;;GAGG;;AAEH;;;;;;;;;;GAUG;;AAEH;;;;GAIG;;AAEH;;;;GAIG;;AAEH;;GAEG;;AAEH;;;GAGG;;AAEH;;;GAGG;;AAEH;;;;;GAKG;;AAEH;;;;GAIG;;AAEH;;;;;;;;;;;;GAYG;;AAEH;;;GAGG;;AAEH;;GAEG;;AAEH;;;;;;;;;GASG;;AAEH;;;;;;;;GAQG;;AAEH;;;;;GAKG;;AAEH;;;;;;;;GAQG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;;;;;;;GAQG;;AAEH;;;GAGG;;AAEH;;GAEG;;AAEH,oBAAoB;AACpB;;;GAGG;;AAEH;;GAEG;;AAEH,iBAAiB;AACjB;;;GAGG;;AAEH;;;;;;;GAOG;;AAEH;;;GAGG;;AAEH;;GAEG;;AAEH;;;GAGG;;AAEH;;;;GAIG;;AAEH,YAAY;AACZ;;;;;;;GAOG;;AAEH;;;GAGG;;AAEH;;;;GAIG;;AAEH,oCAAoC;AACpC;;;GAGG;;AAEH;;;;GAIG;;AAEH;;GAEG;;AAEH;;;;;;;;;GASG;;AAEH;;;;;;;GAOG;;AAEH;;GAEG;;AAEH,YAAY;;;AAGZ;;;GAGG;;AAEH;;GAEG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiCG;;;;AAIH;;;;;;;;;;GAUG","sourcesContent":["body {\n\tfont-family: century-gothic, sans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: antialiased;\n\tcolor: #61869f;\n\tbackground-color: #ffffff;\n\ttext-align: center;\n\tpadding: 0px;\n\tmargin: 0px;\n}\n\n/* clases generales */\n\n.logo img {\n\theight: 60px;\n    width: auto;\n}\n\n.rojo {\n    color: brown;\n}\n\np.error {\n    color: rgb(117, 17, 17);\n\tfont-size: 12.5px;\n}\n\nbutton,\ninput[type=\"submit\"],\ninput[type=\"button\"],\n.btn-atras {\n    /* width: auto; */\n\tbackground-color: #41b6e6;\n\tcolor: white;\n\tborder: 0;\n\tborder-radius: 5px !important;\n\tpadding: 10px 15px;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\toutline: 0;\n\tcursor: pointer;\n    \n\t/* padding: 8px 12px; */\n\t/* margin-top: 15px; */\n\n\ttransition: all 300ms;\n\n\n    /* \n    margin: 5px;\n\tfont-size: 14px;\n\tdisplay: inline-block;\n     */\n}\n\n.filtros {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px 24px;\n  align-items: start;\n  width: 95%;           /* 🔹 ligeramente más ancho */\n  max-width: 1400px;    /* 🔹 más acorde a la tabla */\n  margin: 20px auto;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n}\n\n.filtro {\n  display: flex;\n  flex-direction: column;\n}\n\n.filtro label {\n  margin-bottom: 4px;\n  font-weight: 500;\n  color: #333;\n}\n\n.filtro input,\n.filtro select,\n.filtro .select__control {\n  width: 100%;\n  height: 36px;\n  font-size: 14px;\n  border-radius: 4px;\n}\n\n\n\n.filtros label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 4px; /* antes 6px o más */\n  color: #333;\n}\n\n/* 🔹 Excepción para checkboxes dentro de filtros */\n.filtros label:has(input[type=\"checkbox\"]) {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 0; /* eliminamos el espacio innecesario */\n  font-weight: 500;\n  color: #333;\n}\n\n\n.filtros input,\n.filtros select,\n.filtros .select__control {\n  width: 100%;\n  font-size: 14px;\n  height: 36px;\n  border-radius: 4px;\n}\n\n\nh1.centrar-titulo {\n\ttext-align: center;\n}\n\n.acciones-td {\n    display: flex;\n    /* justify-self: center; */\n    width: auto;\n    justify-content: start;\n}\n\ninput {\n    border: 1px solid rgb(187, 187, 187);\n\ttransition: all 0.3s;\n}\n\ninput:hover {\n    border: 2px solid gray;\n}\n\n.form-group .btn-login{\n    width: 100%;\n}\n\n.btn-registrate {\n    background: white !important;\n\tcolor: black;\n\tmargin-bottom: 0px;\n\twidth: 100%;\n}\n.btn-registrate:hover {\n\tbackground: rgb(240, 240, 240) !important;\n}\n/* Layout */\n\n.layout {\n\twidth: 100%;\n\tmin-height: 100vh;\n\tdisplay: grid;\n\tgrid-template-areas:\n\t\t\"header header header header\"\n\t\t\"navi navi navi navi\"\n\t\t\"content content content content\"\n\t\t\"footer footer footer footer\";\n\tgrid-template-rows: 100px 70px 1fr 70px;\n\n\t/* ✅ CAMBIO CLAVE */\n\tgrid-template-columns: minmax(0, 1fr);\n}\n\n.header {\n\tgrid-area: header;\n\tbackground: white;\n\ttext-align: left;\n\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n\twidth: 100%;\n}\n\n.header h1 {\n\tmargin: auto 0;\n\tmargin-left: 15px;\n}\n\n.navi {\n\tgrid-area: navi;\n\tbackground-color: #41b6e6;\n\tmargin-top: 78px;\n\tdisplay: grid !important;\n\tjustify-content: space-around !important;\n\tpadding: 7px !important;\n\n}\n\n.navi li {\n\tpadding: 15px;\n}\n\n.navi a {\n\tdisplay: block;\n\ttext-transform: uppercase;\n\tcolor: white;\n\ttext-decoration: none;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tpadding: 15px 20px !important;\n\ttransition: all 300ms;\n}\n\n\n.layout-content {\n\tgrid-area: content;\n\tmin-height: 600px;\n\t/* padding: 20px; */\n\twidth: 100%;\n}\n\n.footer {\n\tgrid-area: footer;\n\tbackground: #41b6e6;\n\tborder-top: 1px solid white;\n\ttext-align: center;\n\tline-height: 68px;\n\tpadding: 0 25px;\n\tcolor: white;\n}\n\n.footer a {\n\ttext-decoration: none;\n\tcolor: white;\n}\n\n\n/* INICIO */\n.inicio-container {\n    /* height: 60%; */\n    width: 100%;\n    max-width: 550px;\n    margin: auto;\n    margin-top: 1%;\n    display: flex;\n    flex-direction: column;\n    /* justify-content: center; */\n    align-items: center;\n    gap: 50px;\n}\n\n.titulo-inicio {\n    width: 90%;\n}\n\n.botones-inicio {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n}\n\n.btn-grande {\n  display: flex;\n  flex-direction: column;   /* Icono arriba, texto debajo */\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 280px;             /* ancho fijo o 100% si quieres adaptativo */\n  height: 160px;\n  font-size: 1.2rem;\n  font-weight: bold;\n  background-color: #29a9e0;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.15s ease, background-color 0.2s ease;\n}\n\n.btn-grande:hover {\n  transform: translateY(-2px);\n  background-color: #1f8bbb;\n}\n\n.btn-icon-grande {\n  font-size: 3rem;    /* 👈 icono grande */\n}\n\n.btn-texto {\n  display: block;\n  text-align: center;\n}\n\n\n/* INICIO TICAJE */\n.ticaje-frame {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\t/* justify-content: center; */\n\talign-items: center;\n}\n\n/* GESTION JORNADA lABORAL */\n\n.jornada-activa {\n    margin-top: 30px;\n    width: 90%;\n    min-height: 100px;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n    .jornada-activa .table-listado {\n        width: 100%;\n        max-width: 1300px;\n    }\n\n.table-listado th,\n.table-listado td {\n    height: 55px !important;\n}\n\n.form-jornada-manual {\n  background: #d5dbdc;\n  max-width: 450px;\n  margin: 50px auto;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 15px;\n}\n\n.form-jornada-manual label {\n  font-weight: 600;\n}\n\n.form-jornada-manual .input-layout {\n  width: 100%;\n}\n\n.form-jornada-manual textarea {\n  width: 100%;\n  min-height: 60px;\n}\n\n.form-jornada-manual button.btn-login {\n  align-self: center;\n  width: 100%;\n}\n\n/* Barra de exportación */\n.export-bar {\n  width: 90%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 1em;\n}\n.btn-icon-left { margin-right: 6px; }\n\n/* Paginación */\n.paginacion-bar {\n  width: 90%;\n  margin: 0.5rem auto 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.paginacion-controles {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.paginacion-estado { min-width: 110px; text-align: center; }\n.paginacion-size {\n  padding: 6px 8px;\n  border-radius: 4px;\n}\n\n.consulta-ticajes .distancia-cell {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  white-space: nowrap;\n}\n.consulta-ticajes .distancia-cell .btn-mapa {\n  width: auto;         /* anula el width:100% heredado */\n  min-width: 120px;    /* estabilidad visual */\n}\n\n.consulta-ticajes .th-multi { display: grid; }\n/* Cabeceras con dos líneas */\n.consulta-ticajes .th-multi { display: grid; }\n.consulta-ticajes .th-multi .th-sub { font-weight: 400; }\n\n/* En-rango */\n.consulta-ticajes .estado-cell { display: grid; gap: 4px; }\n.consulta-ticajes .estado { font-weight: 700; }\n.consulta-ticajes .estado.ok { color: green; }\n.consulta-ticajes .estado.ko { color: red; }\n.consulta-ticajes .estado.muted { color: #999; font-weight: 600; }\n\n/* Columna Distancia: fija ancho y permite salto si no cabe */\n.consulta-ticajes .col-distancia { width: 270px; }       /* ← ajusta si lo necesitas */\n.consulta-ticajes .distancia-cell {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;               /* ← permite que los botones bajen a 2ª línea */\n}\n.consulta-ticajes .distancia-cell .btn-mapa {\n  width: auto;                   /* anula width:100% heredado */\n  min-width: 120px;\n  white-space: nowrap;           /* el texto del botón no parte */\n}\n.consulta-ticajes .distancia-placeholder { opacity: .7; }\n\n/* (Opcional) hace que las anchuras se respeten mejor */\n.consulta-ticajes .table-listado { table-layout: fixed; }\n.consulta-ticajes .table-listado th,\n.consulta-ticajes .table-listado td { overflow: hidden; text-overflow: ellipsis; }\n\n\n/* GESTION TICAJE */\n\n.formulario-ticaje {\n    width: 90%;\n}\n\n.registro-fecha {\n\tbackground: rgb(213, 219, 220);\n\n    max-width: 378px;\n\tmargin: 50px auto;\n\tpadding: 30px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\n\talign-items: start;\n\t/* gap: 15px; */\n}\n\n\t.registro-fecha label {\n\t\tfont-weight: 600;\n\n\t}\n\n\t.registro-fecha button[type=\"submit\"] {\n\t\tjustify-self: end;\n\t\tgrid-column: 2/3;\n\t\t/* width: 100px; */\n\t}\n\n\n\t.form-group {\n\t\tmargin-bottom: 20px;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\t/* justify-content: center; */\n\t}\n\n\t\t.form-group label {\n\t\t\tflex: 1 1 100%;\n\t\t\tpadding-bottom: 5px;\n\t\t}\n\n\t\t.form-group select {\n\t\t\twidth: 100%;\t\n\t\t}\n\n\t\t.form-group textarea {\n\t\t\twidth: 100%;\n\t\t\tmin-height: 44px;\n\t\t}\n\n\t    .registro-fecha .btn-login {\n            color: rgb(255, 255, 255);\n            justify-self: center;\n            width: 100%;\n\t    }\n\n\t.btn-login:hover {\n\t\tbackground: rgb(57, 146, 159) !important;\n\t}\n\n\t/* TICAJE EN PROCESO */\n.ticaje-proceso {\n    width: 90%;\n    \n\tmargin-top: 20px;\n\t\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n\n\n.ticaje-proceso h2 {\n\tmargin-bottom: 30px;\n}\n\n.ticaje-proceso .table-listado{\n    max-width: 1000px;\n}\n\n.th-multi {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.1;\n  gap: 2px;\n}\n.th-multi .th-sub {\n  font-weight: 400;\n  opacity: 0.85;\n  font-size: 0.9em;\n}\n\n/* Opcional: fija un ancho cómodo para las columnas dobles */\n.table-listado th.col-estado { width: 210px; vertical-align: bottom; }\n.table-listado th.col-distancia { width: 260px; vertical-align: bottom; }\n\n/* ===== Celdas de Estado (Inicio / Cierre) ===== */\n.col-estado .estado-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.estado { font-weight: 600; }\n.estado.ok { color: #108548; }   /* verde */\n.estado.ko { color: #c2272d; }   /* rojo */\n.estado.muted { color: #999; font-weight: 500; }\n\n/* Alineado vertical agradable en estas columnas */\n.table-listado td.col-estado,\n.table-listado td.col-distancia {\n  vertical-align: middle;\n}\n\n/* ===== Jornadas (listado): columna Distancia ===== */\n.consulta-ticajes .table-listado td.col-distancia {\n  vertical-align: middle;\n}\n\n.consulta-ticajes .table-listado td.col-distancia .distancia-cell{\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  gap: 6px;                 /* igual que Acciones (ajusta a 4–8 si prefieres) */\n  min-width: 0;\n}\n\n/* Igualar alto con los botones de Acciones */\n.consulta-ticajes .table-listado .btn-mapa{\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: auto !important;\n  min-width: max-content;\n  padding: 0 12px;        /* 👉 sólo horizontal */\n  min-height: 34px;       /* 👉 misma “caja” para todos */\n  line-height: 1;         /* coherente con el resto de botones */\n  white-space: nowrap;\n}\n\n/* Placeholder cuando no hay distancia */\n.consulta-ticajes .table-listado td.col-distancia .distancia-placeholder {\n  color: #666;\n}\n\n.consulta-ticajes .table-listado td.col-distancia .btn-mapa{\n  min-width: max-content !important;   /* quita el 120px heredado */\n  margin: 0 !important;                /* que la separación la marque 'gap' */\n  padding: 0 12px;                     /* mismo padding que el resto */\n  min-height: 34px;                    /* misma altura que Acciones */\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.consulta-ticajes .table-listado .badge{\n  background: transparent !important;\n  border: 0 !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  display: inline !important;\n\n  /* <- lo que arregla el tamaño “pequeño” */\n  font-size: inherit !important;\n  line-height: inherit !important;\n\n  font-weight: 700;       /* mismo énfasis que “Fuera de rango” */\n  color: inherit;\n}\n\n/* Reutiliza la misma paleta que usas en En Rango (ok/ko). \n   Si ya tienes .estado.ok / .estado.ko, copia sus colores aquí. */\n.consulta-ticajes .table-listado .badge-ok { \n  color: #137a4b; /* mismo verde que uses en tu .estado.ok */\n}\n.consulta-ticajes .table-listado .badge-ko { \n  color: #d43f3a; /* mismo rojo que uses en tu .estado.ko */\n}\n\n/* Línea auxiliar (validador / fecha) */\n.consulta-ticajes .table-listado .validada-meta{\n  margin-top: 6px;\n  color:#555;\n  font-size: .95em; /* opcional, para que no compita con el Sí/No */\n}\n\n/* En pantallas pequeñas permitimos salto y apretamos un poco */\n@media (max-width: 640px) {\n  .consulta-ticajes .table-listado td.col-distancia .distancia-cell {\n    gap: 4px;\n    flex-wrap: wrap;\n  }\n  .consulta-ticajes .table-listado td.col-distancia .btn-mapa {\n    padding: 6px 10px;\n    font-size: 0.94rem;\n  }\n}\n\n.table-listado .col-validada .estado{\n  display:inline-block;\n  line-height:1.2;\n}\n\n/* ---- Solo JORNADAS: columna Acciones ---- */\n.consulta-ticajes .table-listado th.col-acciones,\n.consulta-ticajes .table-listado td.col-acciones {\n  width: 1%;                 /* encoge al contenido */\n  white-space: nowrap;\n  padding-right: 8px;\n}\n\n/* ⚠️ Neutraliza el min-width global de otros listados */\n.consulta-ticajes .table-listado td.botones-usuario--jornadas {\n  min-width: 0 !important;   /* ← quita el 420px heredado */\n  padding-right: 24px !important;   /* separa visualmente de la siguiente columna */\n  width: 1%;                 /* deja que encoja */\n}\n\n/* Fila de botones más pegados */\n.consulta-ticajes .table-listado td.botones-usuario--jornadas .btn-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Botón compacto solo aquí */\n.consulta-ticajes .table-listado td.botones-usuario--jornadas .btn--compact {\n  font-size: 0.9rem;\n  padding: 6px 10px;\n  line-height: 1.1;\n  white-space: nowrap;\n}\n\n/* Botón-chip de distancia con estado */\n.btn-mapa.btn-mapa--chip {\n  /* mismas bases que tus botones; solo aseguramos consistencia */\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: max-content;\n  padding: 6px 12px;\n  white-space: nowrap;\n  border-width: 1px;\n}\n\n/* Estado: en rango */\n.btn-mapa.btn-mapa--chip.is-ok {\n  background: #e7f8ed;\n  color: #0f5132;\n  border-color: #b6f0c6;\n}\n.btn-mapa.btn-mapa--chip.is-ok:hover {\n  background: #dff5e7;\n}\n\n/* Estado: fuera de rango */\n.btn-mapa.btn-mapa--chip.is-ko {\n  background: #fdeceb;\n  color: #842029;\n  border-color: #f5c2c7;\n}\n.btn-mapa.btn-mapa--chip.is-ko:hover {\n  background: #f9e0df;\n}\n\n/* Estado: sin dato (cierre no disponible) */\n.btn-mapa.btn-mapa--chip.is-muted {\n  background: #f1f3f5;\n  color: #6c757d;\n  border-color: #e9ecef;\n}\n.btn-mapa.btn-mapa--chip.is-muted:hover {\n  background: #e9ecef;\n}\n\n/* La fila de distancias queda igual de compacta que acciones */\n.col-distancia .distancia-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;           /* igual que usamos en acciones */\n  flex-wrap: nowrap;\n  white-space: nowrap;\n}\n\n\n@media (max-width: 1280px) {\n  .consulta-ticajes .table-listado td.botones-usuario--jornadas .btn--compact {\n    font-size: 0.85rem;\n    padding: 6px 8px;\n  }\n}\n\n\n/* ===== Extras de calidad de vida ===== */\n.ordenable { cursor: pointer; }\n.ordenable:hover { text-decoration: underline; }\n\n.table-listado .no-results {\n  text-align: center;\n  padding: 1rem;\n  color: #666;\n}\n\n/* Botón de acciones con icono: tamaño consistente */\n.table-listado td:last-child .btn-mapa {\n  min-width: 36px;\n  padding: 6px 10px;\n}\n\n\n/* GESTION ORDENES */\n.form-orden {\n    width: 90%;\n    margin: auto;\n}\n\n    .form-orden form {\n        max-width: 500px;\n        margin-top: 150px;\n        \n        display: grid;\n        grid-template-columns: 2fr 3fr;\n        gap: 20px;\n    }\n\n    .form-orden textarea {\n        height: 70px;\n    }\n    .form-orden .registro-fecha .btn-login {\n        grid-column: span 2;\n    }\n\n/* LISTADO ORDENES */\n\n.listado-container {\n    width: 90%;\n    margin: auto;\n}\n\n.listado-container .table-listado-padre {\n    margin: auto;\n    max-width: 1200px;\n}\n\n.listado-container .orden-trabajo {\n    min-width: 1200px !important;\n}\n\n.listado-container .orden-trabajo td:last-child {\n    width: 325px;\n}\n\n.listado-container .modal-content {\n    width: 500px !important;\n}\n.listado-container .modal-content .checkbox-group {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n}\n\n\n/* GESTION CLIENTES */\n\n.cliente-frame {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n\t.cliente-frame h1 {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.form-agregar-cliente {\n\t\twidth: 90%;\n        margin: auto;\n\t}\n\n\t\t.form-agregar-cliente form {\n\t\t\twidth: 100%;\n            max-width: 1300px;\n            margin: 20px auto;\n            margin-top: 25px;\n\t\t}\n\n\t\t\t.form-agregar-cliente input {\n                padding: 0;\n                padding-left: 6px;\n\t\t\t\theight: 44px;\n\t\t\t}\n\t\t\t.form-agregar-cliente button {\n                height: 44px;\n                border-radius: 0 !important;\n\t\t\t}\n\n    .cliente-frame .filtros {\n        max-width: 520px;\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    \n    \n\t.tabla-clientes {\n\t\tmargin-top: 40px;\n\t\twidth: 90%;\n        margin: auto;\n\t}\n\n        .tabla-clientes .table-listado-padre {\n            max-width: 1000px ;\n            margin: auto;\n        }\n\n        .tabla-clientes .tabla-listado-clientes {\n            width: 100%;\n            /* max-width: 1300px; */\n            margin: auto;\n            margin-top: 50px;\n            width: max-content;\n            table-layout: auto;\n            border-collapse: collapse;\n\t\t}\n        .tabla-clientes th:nth-child(2),\n        .tabla-clientes td:nth-child(2) {\n            width: 500px !important;\n            max-width: 500px !important;\n        }\n\n\n        .acciones-columna {\n            display: flex;\n            padding: 2px;\n            gap: 5px;\n            /* max-width: 400px; */\n        }\n        .acciones-columna button {\n            height: 43px;\n        }\n\n        .fila-centro td:nth-child(2) {\n            max-width: 500px;\n        }\n\n\t\t.subtr {\n\t\t\tpadding-left: 20px;\n\t\t}\n\n        .cliente-frame .table-listado th:nth-child(2),\n        .cliente-frame .table-listado td:nth-child(2) {\n            width: 400px;\n        }\n        .cliente-frame .table-listado th:nth-child(3),\n        .cliente-frame .table-listado td:nth-child(3)  {\n            width: 150px;\n        }\n        .cliente-frame .table-listado th:nth-child(4),\n        .cliente-frame .table-listado td:nth-child(4)  {\n            width: 450px;\n        }\n\n        .cliente-frame .acciones-td button:last-child{\n            width: 130px;\n        }\n        \n\n/*   TAREAS   */\n\n/* === Contenedor general del formulario de tareas === */\n.form-orden {\n  max-width: 900px;\n  margin: 90px auto 40px;\n  padding: 24px 32px 28px;\n  border-radius: 12px;\n  background: #f3f6f9;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.06);\n}\n\n/* Título del bloque */\n.form-orden h2 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 18px;\n}\n\n/* === Layout en grid etiqueta / campo === */\n.registro-fecha {\n  display: grid;\n  grid-template-columns: 1.1fr 2fr;\n  column-gap: 22px;\n  row-gap: 14px;\n  align-items: center;\n}\n\n/* Etiquetas del formulario */\n.registro-fecha label {\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: #29323d;\n}\n\n/* Inputs y textarea (usa tu clase estándar) */\n.registro-fecha .input-layout,\n.registro-fecha textarea,\n.registro-fecha input[type=\"date\"],\n.registro-fecha input[type=\"text\"] {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid #d0d7e2;\n  font-size: 0.95rem;\n  background: #f9fcff;\n  box-sizing: border-box;\n}\n\n.registro-fecha .input-layout:focus,\n.registro-fecha textarea:focus,\n.registro-fecha input[type=\"date\"]:focus {\n  outline: none;\n  border-color: #40a9ff;\n  box-shadow: 0 0 0 2px rgba(64,169,255,0.2);\n}\n\n/* Textarea un poco más alta y alineada */\n.registro-fecha textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* === Bloque prioridad / fecha límite en una sola fila === */\n.form-group-inline {\n  grid-column: 1 / -1; /* ocupa las dos columnas del grid */\n  display: flex;\n  gap: 16px;\n  margin-top: 4px;\n}\n\n.form-group-inline > div {\n  flex: 1;\n}\n\n/* === react-select (classNamePrefix=\"select\") === */\n.form-orden .select__control {\n  min-height: 38px;\n  border-radius: 6px;\n  border-color: #d0d7e2;\n  box-shadow: none;\n  background: #f9fcff;\n}\n\n.form-orden .select__control--is-focused {\n  border-color: #40a9ff;\n  box-shadow: 0 0 0 2px rgba(64,169,255,0.2);\n}\n\n.form-orden .select__placeholder {\n  font-size: 0.9rem;\n  color: #8b98aa;\n}\n\n.form-orden .select__multi-value {\n  background: #e8f4ff;\n}\n\n.form-orden .select__multi-value__label {\n  font-size: 0.85rem;\n}\n\n/* que los Selects no se peguen a la etiqueta */\n.form-orden .select__control {\n  margin-top: 2px;\n}\n\n/* === Botón principal === */\n.form-orden .btn-login {\n  grid-column: 1 / -1;         /* ocupa todo el ancho del formulario */\n  margin-top: 10px;\n  padding: 10px 16px;\n  border-radius: 8px;\n  border: none;\n  font-weight: 600;\n  font-size: 0.98rem;\n}\n\n.form-orden .btn-login:disabled {\n  opacity: 0.7;\n  cursor: default;\n}\n\n/* === Responsive: en móvil, una sola columna === */\n@media (max-width: 768px) {\n  .form-orden {\n    margin: 80px 12px 30px;\n    padding: 20px 18px 24px;\n  }\n\n  .registro-fecha {\n    grid-template-columns: 1fr;\n    row-gap: 10px;\n  }\n\n  .registro-fecha label {\n    margin-top: 4px;\n  }\n\n  .form-group-inline {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n\n/*  TABLEROS KANBAN  */\n.kanban-wrapper {\n  padding: 20px;\n}\n\n.kanban-board {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  overflow-x: auto;\n  min-height: 450px;      /* alto mínimo del área del tablero */\n  margin-bottom: 40px;    /* separación fija con el botón */\n}\n\n.kanban-column {\n  background: #f4f6f8;\n  border-radius: 8px;\n  padding: 8px;\n  min-width: 260px;\n  max-width: 320px;\n  display: flex;\n  flex-direction: column;\n}\n\n.kanban-column--active {\n  background: #e8f6ff;\n}\n\n.kanban-column-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 8px 4px;\n  font-weight: 600;\n  color: #084298;\n  border-bottom: 1px solid rgba(0,0,0,0.06);\n}\n\n.kanban-column-count {\n  font-size: 0.85rem;\n  background: white;\n  border-radius: 999px;\n  padding: 2px 8px;\n  border: 1px solid rgba(0,0,0,0.08);\n}\n\n.kanban-column-body {\n  margin-top: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kanban-card {\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 8px 10px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n  font-size: 0.9rem;\n  cursor: grab;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.kanban-card--dragging {\n  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.2);\n}\n\n.kanban-card-title {\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n.kanban-card-desc {\n  color: #555;\n  font-size: 0.85rem;\n}\n\n.kanban-card-meta {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n}\n\n.badge-prioridad {\n  border-radius: 999px;\n  padding: 2px 8px;\n  font-size: 0.75rem;\n  text-transform: capitalize;\n}\n\n.badge-prioridad--baja {\n  background: #e7f8ed;\n  color: #0f5132;\n}\n\n.badge-prioridad--normal,\n.badge-prioridad--media {\n  background: #e8f6ff;\n  color: #084298;\n}\n\n.badge-prioridad--alta,\n.badge-prioridad--critica {\n  background: #fdeceb;\n  color: #842029;\n}\n\n.badge-fecha {\n  font-size: 0.75rem;\n  background: #fff7e6;\n  color: #664d03;\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n.kanban-card-footer {\n  margin-top: 4px;\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.kanban-destino {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.kanban-card-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.kanban-card-avatar img,\n.avatar-fallback.avatar-fallback--small {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.kanban-card-header-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.kanban-card-creator-name {\n  font-weight: 600;\n  line-height: 1.1;\n}\n\n.kanban-card-creator-label {\n  font-size: 0.8rem;\n  color: #777;\n}\n\n/* Semáforo fecha */\n.badge-fecha--ok {\n  background: #e6f4ea;\n  color: #0f5132;\n}\n\n.badge-fecha--warning {\n  background: #fff3cd;\n  color: #664d03;\n}\n\n.badge-fecha--critica {\n  background: #f8d7da;\n  color: #842029;\n}\n\n\n/* Botón similar a tus botones azules */\n.btn-toggle-desplegable {\n  background-color: #29abe2;\n  border: none;\n  border-radius: 4px;\n  color: #ffffff;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.btn-toggle-desplegable:hover {\n  background-color: #1b8cbc;\n}\n\n\n.tareas-creadas-desplegable {\n  margin-top: 40px !important; /* antes 30px */\n}\n\n/* El card blanco del desplegable ocupa todo el ancho */\n.tareas-creadas-desplegable-body {\n  margin-top: 15px;\n  padding: 20px;\n  background: #ffffff;\n  border-radius: 6px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.tabla-clientes--embebida {\n  max-width: none !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n/* La tabla ocupa todo el ancho disponible */\n.tabla-listado-clientes {\n  width: 100%;\n  table-layout: auto;\n}\n\n.tabla-listado-clientes th:nth-child(1),\n.tabla-listado-clientes td:nth-child(1) {\n  width: 40%;\n}\n\n.tabla-listado-clientes th:nth-child(2),\n.tabla-listado-clientes td:nth-child(2),\n.tabla-listado-clientes th:nth-child(3),\n.tabla-listado-clientes td:nth-child(3),\n.tabla-listado-clientes th:nth-child(4),\n.tabla-listado-clientes td:nth-child(4),\n.tabla-listado-clientes th:nth-child(5),\n.tabla-listado-clientes td:nth-child(5) {\n  width: 12%;\n}\n\n.tabla-listado-clientes th:nth-child(6),\n.tabla-listado-clientes td:nth-child(6) {\n  width: 22%;\n}\n\n.peticiones-horizontal {\n  display: flex;\n  flex-wrap: wrap;           /* por si en pantallas pequeñas se rompe */\n  gap: 4px 10px;\n  font-size: 0.85rem;\n  line-height: 1.2;\n  justify-content: flex-start;\n  width: 100%;\n  white-space: nowrap;       /* intenta mantenerlo en una sola línea */\n}\n\n\n/* Tabla de \"tareas creadas por mí\" dentro de tabla-clientes */\n.tabla-listado-tareas-creadas {\n  width: 100%;\n}\n\n/* Reparto de columnas solo para esta tabla */\n.tabla-listado-tareas-creadas th:nth-child(1),\n.tabla-listado-tareas-creadas td:nth-child(1) {\n  width: 32%;   /* Título */\n}\n\n.tabla-listado-tareas-creadas th:nth-child(2),\n.tabla-listado-tareas-creadas td:nth-child(2) {\n  width: 10%;   /* Prioridad */\n}\n\n.tabla-listado-tareas-creadas th:nth-child(3),\n.tabla-listado-tareas-creadas td:nth-child(3) {\n  width: 13%;   /* Estado global */\n}\n\n.tabla-listado-tareas-creadas th:nth-child(4),\n.tabla-listado-tareas-creadas td:nth-child(4),\n.tabla-listado-tareas-creadas th:nth-child(5),\n.tabla-listado-tareas-creadas td:nth-child(5) {\n  width: 13%;   /* Fechas */\n}\n\n/* Columna de peticiones: más ancha y con mínimo */\n.tabla-listado-tareas-creadas th.col-peticiones,\n.tabla-listado-tareas-creadas td.col-peticiones {\n  width: 19%;\n  min-width: 240px;\n}\n\n/* Versión embebida de la tabla (debajo del tablero) */\n.tabla-clientes--embebida {\n  width: 100% !important;\n  max-width: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n/* Aquí rompemos el centrado de .tabla-clientes .tabla-listado-clientes */\n.tabla-clientes--embebida .tabla-listado-clientes {\n  width: 100% !important;\n  margin: 20px 0 0 0 !important;   /* margen solo arriba */\n  text-align: left;\n}\n\n.tareas-depto-filtros {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.tareas-depto-label {\n  font-weight: 600;\n}\n\n.tareas-depto-select {\n  max-width: 260px;\n}\n\n.tareas-depto-loading,\n.tareas-depto-empty {\n  font-style: italic;\n  color: #666;\n}\n\n.tareas-depto-hint {\n  font-style: italic;\n  margin-bottom: 20px;\n  color: #666;\n}\n\n/* Departamento asociado en tarjeta */\n.kanban-card-depto {\n  margin-bottom: 4px;\n}\n\n.kanban-depto-tag {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #eef2ff;   /* azul muy suave */\n  color: #312e81;        /* azul oscuro */\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n\n.tarea-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.tarea-panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  border-bottom: 1px solid rgba(0,0,0,0.06);\n  padding-bottom: 8px;\n}\n\n.tarea-panel-title {\n  margin: 0;\n  font-size: 1.1rem;\n}\n\n.tarea-panel-subtitle {\n  margin: 4px 0 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.tarea-panel-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  background: #f4f6f8;\n}\n\n.prioridad-baja { background: #e7f8ed; color: #0f5132; }\n.prioridad-normal { background: #e8f6ff; color: #084298; }\n.prioridad-alta { background: #fff3cd; color: #664d03; }\n.prioridad-critica { background: #fdeceb; color: #842029; }\n\n.tarea-panel-header-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.tarea-panel-meta-item {\n  white-space: nowrap;\n}\n\n.tarea-panel-body {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.tarea-panel-col {\n  flex: 1;\n  min-width: 0;\n}\n\n.tarea-panel-col--info {\n  border-right: 1px solid rgba(0,0,0,0.06);\n  padding-right: 12px;\n}\n\n.tarea-panel-section-title {\n  margin: 0 0 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.tarea-panel-descripcion {\n  margin: 0 0 12px;\n  font-size: 0.9rem;\n}\n\n.tarea-panel-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0,1fr));\n  gap: 8px 16px;\n  font-size: 0.85rem;\n}\n\n.tarea-panel-info-label {\n  display: block;\n  color: #777;\n  font-size: 0.8rem;\n}\n\n.tarea-panel-info-value {\n  font-weight: 600;\n}\n\n.tarea-panel-field {\n  margin-bottom: 12px;\n}\n\n.tarea-panel-label {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.tarea-panel-help {\n  display: block;\n  margin-top: 4px;\n  font-size: 0.75rem;\n  color: #777;\n}\n\n.tarea-panel-textarea {\n  resize: vertical;\n}\n\n.tarea-panel-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 8px;\n  border-top: 1px solid rgba(0,0,0,0.06);\n  padding-top: 8px;\n}\n\n/* Botones coherentes con tu estilo */\n.btn-principal {\n  background-color: #29abe2;\n  border: none;\n  color: #fff;\n  border-radius: 4px;\n  padding: 6px 14px;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.btn-principal:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.btn-secundario {\n  background-color: #f4f6f8;\n  border: 1px solid #d0d7de;\n  color: #333;\n  border-radius: 4px;\n  padding: 6px 14px;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .tarea-panel-body {\n    flex-direction: column;\n  }\n  .tarea-panel-col--info {\n    border-right: none;\n    padding-right: 0;\n    border-bottom: 1px solid rgba(0,0,0,0.06);\n    padding-bottom: 12px;\n    margin-bottom: 12px;\n  }\n}\n\n/* --- MODAL CENTRADO Y POR ENCIMA DE NAVBAR --- */\n.modal-historial-overlay {\n  position: fixed;\n  inset: 0;                        /* top:0,left:0,width/height 100% */\n  background: rgba(0,0,0,0.45);\n  z-index: 999999;                 /* por encima de la navbar */\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;         /* 👈 evita deformaciones con scroll */\n  overflow-y: auto;                /* 👈 scroll del overlay cuando haga falta */\n  padding: 40px 16px;              /* margen superior/inferior para respirar */\n}\n\n/* --- CONTENEDOR DEL HISTORIAL --- */\n.modal-historial-contenido {\n  background: #fff;\n  width: 900px;\n  max-width: 90vw;\n  border-radius: 12px;\n  position: relative;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 35px rgba(0,0,0,0.25);\n}\n\n/* --- X DE CERRAR --- */\n.historial-close-btn {\n  position: absolute;\n  top: 12px;\n  right: 22px;\n  font-size: 22px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  z-index: 10;\n}\n\n/* --- SCROLL INTERNO, SIEMPRE 1 COLUMNA --- */\n.historial-scroll {\n  margin-top: 10px;\n  padding-right: 12px;\n  overflow-y: auto;\n  max-height: 70vh;                /* 👈 límite de alto del listado */\n}\n\n/* --- TARJETA DEL EVENTO DEL HISTORIAL --- */\n.historial-item-card {\n  width: 100%;\n  background: #f9f9f9;\n  border: 1px solid #e4e4e4;\n  border-radius: 10px;\n  padding: 14px 18px;\n  margin-bottom: 14px;\n  display: block;                  /* 👈 garantizamos una sola columna */\n}\n\n/* --- CABECERA DEL EVENTO: AVATAR + NOMBRE + FECHA --- */\n.historial-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.avatar-small {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #ddd;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 700;\n  color: #555;\n  font-size: 15px;\n}\n\n.historial-header-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.historial-user {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.historial-date {\n  font-size: 12px;\n  opacity: 0.8;\n}\n\n/* --- TEXTO DESCRIPTIVO --- */\n.historial-body {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #444;\n}\n\n.historial-comentario {\n  margin-top: 6px;\n  padding-left: 6px;\n  border-left: 3px solid #aaa;\n  font-style: italic;\n  opacity: 0.9;\n}\n\n\n/* ControlSIL */\n\n/* =========================\n   SIL Control - Editor\n========================= */\n\n/* Layout general del editor */\n.sil-grids {\n  display: grid;\n  grid-template-columns: 1fr 360px;\n  gap: 16px;\n  align-items: start;\n}\n\n.sil-toolbar {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-bottom: 14px;\n}\n\n.sil-info { margin-left: 10px; }\n.sil-modal-sub { margin-top: -8px; }\n.muted { opacity: .65; }\n.rojo { color: #c0392b; }\n\n/* Tablero */\n.sil-grid-contenedor--tablero {\n  position: relative;\n  width: 100%;\n  overflow: auto;\n  background: #fff;        /* limpio */\n}\n\n\n.sil-grid-contenedor--tablero > .react-grid-layout{\n  min-height: 100% !important;\n}\n\n.sil-celda-hover{\n  position: absolute;\n  pointer-events: none;\n  background: rgba(255,0,0,.12);\n  border: 1px solid rgba(255,0,0,.35);\n  border-radius: 8px;\n  z-index: 10;\n}\n\n.sil-modo-colocar{ cursor: crosshair; outline: 2px dashed rgba(65,182,230,.8); }\n\n\n\n/* Badge de modo colocar */\n.sil-badge-colocar {\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: rgba(65, 182, 230, 0.15);\n}\n\n/* Banco */\n.sil-grid-bloque--banco {\n  position: sticky;\n  top: 90px; /* navbar fixed-top */\n}\n\n.sil-banco {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.sil-banco-item {\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid rgba(0,0,0,.08);\n  padding: 10px;\n}\n\n.sil-banco-titulo { font-weight: 700; font-size: 13px; }\n.sil-banco-sub { font-size: 12px; margin-top: 4px; }\n.sil-banco-acciones { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 10px; }\n\n.sil-btn-cancelar-colocar {\n  margin-top: 10px;\n}\n\n/* Tarjetas del grid */\n.sil-nodo-card {\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid rgba(0,0,0,.08);\n  overflow: hidden;\n  height: 100%;\n}\n\n.sil-nodo-card-inner{\n  height: 100%;\n  padding: 10px 12px;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;   /* 👈 CLAVE */\n  gap: 6px;                      /* separación natural */\n}\n\n..sil-nodo-titulo {\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 1.15;\n}\n\n.sil-nodo-usuario {\n  font-size: 12px;\n  color: #555;\n}\n\n/* Acciones en UNA fila */\n.sil-nodo-acciones {\n  display: flex;\n  gap: 6px;\n  flex-wrap: nowrap;   /* 👈 evita stacking vertical */\n  margin-top: auto;    /* 👈 empuja botones abajo SIN estirar todo */\n}\n\n\n.sil-checkbox { display: flex; gap: 8px; align-items: center; }\n\n/* ✅ Botones compactos SOLO en SIL */\n.sil-nodo-acciones .btn-mapa{\n  padding: 6px 10px !important;\n  font-size: 12px !important;\n  border-radius: 6px !important;\n  min-height: 30px;\n}\n\n/* Lienzo de ControlSIL */\n/* Toolbar bonita */\n.sil-toolbar{\n  display:flex;\n  gap:10px;\n  align-items:center;\n  flex-wrap:wrap;\n}\n\n.sil-canvas-controls{\n  display:flex;\n  gap:10px;\n  align-items:center;\n  padding:8px 10px;\n  border:1px solid rgba(0,0,0,.08);\n  border-radius:10px;\n  background:rgba(255,255,255,.85);\n}\n\n.sil-canvas-title{\n  font-weight:700;\n  font-size:13px;\n  opacity:.8;\n  margin-right:6px;\n}\n\n.sil-canvas-controls label{\n  display:flex;\n  flex-direction:column;\n  gap:4px;\n  font-size:12px;\n}\n\n.sil-canvas-controls input{\n  width:90px;\n  padding:6px 8px;\n  border:1px solid rgba(0,0,0,.15);\n  border-radius:8px;\n}\n\n/* Tarjetas */\n.sil-nodo-card { height: 100%; }\n\n.sil-nodo-card-inner{\n  height:100%;\n  padding:10px 12px;\n  border:1px solid rgba(0,0,0,.10);\n  border-radius:10px;\n  background:#fff;\n  display:flex;\n  flex-direction:column;\n  justify-content:flex-start;\n  gap:6px;\n}\n\n.sil-nodo-titulo{ font-weight:700; font-size:13px; line-height:1.15; }\n.sil-nodo-usuario{ font-size:12px; color:#555; }\n.sil-nodo-usuario.muted{ opacity:.6; }\n\n.sil-nodo-acciones{\n  display:flex;\n  gap:6px;\n  flex-wrap:nowrap;\n  margin-top:auto;\n}\n\n.sil-nodo-acciones .btn-mapa{\n  padding:6px 10px !important;\n  font-size:12px !important;\n  border-radius:6px !important;\n  min-height:30px;\n}\n\n\n/* =========================\n   PANEL REPORTES SIL\n========================= */\n\n.sil-panel {\n  padding: 20px;\n}\n\n.sil-panel-title {\n  margin-bottom: 10px;\n}\n\n.sil-panel-loading {\n  padding: 20px;\n}\n\n.sil-panel-error {\n  color: #c0392b;\n  margin-bottom: 12px;\n}\n\n/* Scroll horizontal superior */\n.sil-panel-scroll-top {\n  overflow-x: auto;\n  height: 16px;\n  margin-bottom: 6px;\n  border-radius: 8px;\n  border: 1px solid rgba(0,0,0,.06);\n  background: rgba(255,255,255,.7);\n}\n\n/* Canvas principal */\n.sil-panel-canvas {\n  height: calc(100vh - 220px);\n  overflow: auto;\n  border: 1px solid rgba(0,0,0,.06);\n  border-radius: 10px;\n  background: #fff;\n}\n\n/* =========================\n   TARJETAS\n========================= */\n\n.sil-reporte-card {\n  height: 100%;\n  border-radius: 10px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 6px;\n  cursor: default;\n}\n\n/* Estados */\n.sil-reporte-verde {\n  background: #dff6e4;\n  border: 1px solid rgba(39,174,96,.35);\n}\n\n.sil-reporte-amarillo {\n  background: #fff4cc;\n  border: 1px solid rgba(241,196,15,.45);\n}\n\n.sil-reporte-rojo {\n  background: #ffe0e0;\n  border: 1px solid rgba(192,57,43,.35);\n}\n\n.sil-reporte-expirado {\n  background: #ffffff;\n  border: 1px dashed rgba(0,0,0,.25);\n}\n\n/* Contenido */\n.sil-reporte-titulo {\n  font-weight: 800;\n  line-height: 1.15;\n}\n\n.sil-reporte-usuario {\n  font-size: 13px;\n  color: #777;\n}\n\n.sil-reporte-fecha {\n  font-size: 12px;\n  color: #777;\n  text-align: right;\n}\n\n\n/* TICAJE DE EMPLEADOS */\n.ticaje-empleados {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n}\n        \n\t.consulta-ticajes {\n\t\twidth: 90%;\n        margin: auto;\n\t}\n\n\t\t.consulta-ticajes h2 {\n\t\t\tmargin-bottom: 20px;\n            text-align: start;\n\t\t}\n\n        .consulta-ticajes th {\n            color: black;\n            cursor: pointer;\n            transition: color .1s ease;\n        }\n        \n        .consulta-ticajes th:hover {\n            color: rgb(113, 113, 113);\n            \n        }\n\n\t\t.consulta-ticajes .btn-mapa {\n\t\t\twidth: 100%;\n            max-width: 87px;\n            /* margin: 8px 0; */\n\t\t}\n\t\n        .table-listado-padre {\n            margin-top: 10px;\n            /* max-width: 100%; */\n            overflow-x: auto;\n            width: 100%;\n        }\n        \n            .table-listado-padre .table-listado {\n                /* margin: 0; */\n                min-width: 1500px;\n                width: max-content;\n                table-layout: auto;\n                border-collapse: collapse;\n            }\n\n            /* .consulta-ticajes .table-listado th:nth-child(1) {\n                width: 75px;\n            }\n\n            .consulta-ticajes .table-listado th:nth-child(3) {\n                width: 275px;\n            }\n            .consulta-ticajes .table-listado th:nth-child(2),\n            .consulta-ticajes .table-listado th:nth-child(4),\n            .consulta-ticajes .table-listado th:nth-child(5) {\n                width: 150px;\n            }\n            .consulta-ticajes .table-listado th:nth-child(6) {\n                width: 120px;\n            } */\n\n            .consulta-ticajes .table-listado th,\n            .consulta-ticajes .table-listado td {\n                padding-right: 20px;\n            }\n\n            .acciones-td {\n                white-space: wrap;\n                min-width: 100px;\n                margin: 2px;\n            }\n\n        .exportar-botones-padre {\n            width: 100%;\n            display: flex;\n            justify-content: end;\n        }\n        .exportar-botones {\n            /* width: 40%; */\n            display: grid;\n            grid-template-columns: repeat(4,160px);\n            /* justify-content: end; */\n            align-items: center;\n            gap: 10px;\n            margin-top: 1em;\n        }\n        .exportar-botones .btn-mapa {\n            max-width: none;\n            width: 100%;\n        }\n        \n\n\t.fingerprint-checker {\n\t\twidth: 90%;\n\t\tmargin-top: 25px;\n\t\tmargin-bottom: 35px;\n\t}\n\n\t\t.fingerprint-checker button {\n\t\t\tmargin-top: 5px;\n\t\t}\n\n\t\t.fingerprint-checker p {\n\t\t\tmargin-top: 10px;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\n/* CREAR USUARIOS */\n.form-crear-usuario {\n    width: 90%;\n    margin: auto;\n}\n.formulario-usuario {\n    background: #D5DBDC;\n    width: auto;\n    max-width: 600px;\n    margin: auto;\n    margin-top: 100px;\n    padding: 20px;\n\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n\n    align-items: center;\n    column-gap: 20px;\n}\n\n.formulario-usuario select {\n    width: 100%;\n    max-width: 187px;\n    height: 28px;\n}\n\n.formulario-usuario button {\n    width: 100%;\n    max-width: 187px;\n    height: 050px;\n}\n\n/* Mantener tu layout de 2 columnas tal cual ya lo tengas */\n\n/* Contenedor input + botón compacto */\n.input-with-button {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Asegura que el input ocupa todo el ancho disponible */\n.input-with-button input {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Botón ojo compacto, mismo alto que el input sin desbordar */\n.btn-eye {\n  border: none;\n  cursor: pointer;\n  padding: 0 10px;\n  height: 32px;            /* ajusta a tu altura de input */\n  min-width: 38px;\n  border-radius: 4px;\n  background: #29a9e0;     /* tu color de botones (como .btn-login light) */\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n/* Versión accesible para lectores de pantalla */\n.sr-only {\n  position: absolute;\n  width: 1px; height: 1px;\n  padding: 0; margin: -1px;\n  overflow: hidden; clip: rect(0,0,0,0);\n  white-space: nowrap; border: 0;\n}\n\n/* Si tus inputs son más altos, sincroniza: */\n.formulario-usuario input[type=\"text\"],\n.formulario-usuario input[type=\"email\"],\n.formulario-usuario input[type=\"password\"],\n.btn-eye {\n  height: 34px;            /* mismo valor para todos para que alineen */\n}\n\n/* Opcional: que el botón no crezca en móvil */\n@media (max-width: 640px) {\n  .input-with-button { gap: 6px; }\n  .btn-eye { height: 32px; min-width: 34px; padding: 0 8px; }\n}\n\n\n/* GESTION USUARIOS */\n.usuarios-page {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n    .usuarios-page h2 {\n        width: 90%;\n        text-align: start;\n        margin: 0;\n        \n    }\n\n    .registro-usuarios {\n        width: 85%;\n        margin-top: 15px;\n        margin: 20px 0;\n    }\n    \n        .registro-usuarios button {\n            width: auto;\n        }\n\n\n        /* REGISTRAR NUEVO USUARIO */\n            .registro-usuarios .modal-form {\n                display: grid;\n                grid-template-columns: repeat(2, auto 1fr);\n            }\n\n            .modal-form button {\n                grid-column-end: -1;\n                width: 100% !important;\n            }\n        \n\n    \n    .gestion-usuarios {\n        width: 90%;\n        margin: auto;\n    }\n\n        .gestion-usuarios .modal-content {\n            max-width: 600px;\n        }\n\n        .editar-user {\n            max-width: 700px !important;\n        }\n\n            .modal-options {\n\n                margin: 20px 0;\n\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                gap: 20px;\n            }\n\n            .modal-options select{\n                width: 50%;\n                max-width: 130px;\n                height: 44px;\n                border-radius: 5px;\n            }\n\n    .table-listado {\n        width: 90%;\n        /* border-collapse: collapse; */\n        margin: 20px auto;\n        text-align: left;\n    }\n\n    .gestion-usuarios .table-listado {\n        max-width: 1300px !important;\n        min-width: 1117px !important;\n\n    }\n\n    .gestion-usuarios .table-listado th:nth-child(1) {\n    width: 130px; /* DNI */\n    }\n    .gestion-usuarios .table-listado th:nth-child(2) {\n    width: 240px; /* Nombre */\n    }\n    .gestion-usuarios .table-listado th:nth-child(3) {\n    width: 240px; /* Apellidos */\n    }\n    .gestion-usuarios .table-listado th:nth-child(4) {\n    width: 240px; /* Email */\n    }\n    .gestion-usuarios .table-listado th:nth-child(5) {\n    width: 120px; /* Teléfono */\n    }\n    .gestion-usuarios .table-listado th:nth-child(6) {\n    width: 100px; /* Rol */\n    }\n    .gestion-usuarios .table-listado th:nth-child(7) {\n    width: 140px; /* Manager */\n    }\n    .gestion-usuarios .table-listado th:nth-child(8) {\n    min-width: 400px; /* Acciones */\n    }\n\n\n    .gestion-usuarios .table-listado td:last-child {\n        display: grid;\n        grid-template-columns: repeat(4, 91px);\n        gap: 5px;\n        padding-right: 10px !important;\n    }\n    .gestion-usuarios .table-listado td:last-child button {\n        width: 100%;\n    }\n\n        .gestion-usuarios .acciones-td .btn-mapa:last-child{\n            width: 82px;\n        }\n\n        /* Ajustar botones dentro de la tabla */\n        .table-listado td button {\n            margin: 5px;\n            padding: 8px 12px;\n            font-size: 14px;\n            border-radius: 5px;\n            /* display: inline-block; */\n        }\n\n        .table-listado th {\n            color: black;\n            transition: color .2s ease;\n        }\n        \n        .ordenable:hover {\n            color: rgb(113, 113, 113);\n        }\n    \n.gestion-usuarios .acciones-td.flex {\n  display: table-cell !important;\n}\n\n.gestion-usuarios .acciones-td.flex .button-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  justify-content: flex-start;\n}\n\n.gestion-usuarios .acciones-td.flex .button-container button {\n  width: auto !important;\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\ntd.botones-usuario {\n  display: table-cell !important;\n  white-space: nowrap;\n  min-width: 420px;\n}\n\n\ntd.botones-usuario .btn-mapa {\n  width: auto !important;\n  display: inline-block !important;\n  flex: 0 0 auto;\n  white-space: nowrap;\n  margin: 2px;\n}\n\n.td-invisible {\n  width: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  border: none !important;\n  visibility: hidden !important;\n}\n\n/* Formulario de edición (modal) */\n    .formulario-usuario-editar {\n    background: #D5DBDC;\n    max-width: 434px;\n    margin: auto;\n    margin-top: 100px;\n    padding: 20px;\n\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 20px;\n    row-gap: 16px;\n    }\n\n    .formulario-usuario-editar h2 {\n    grid-column: 1 / -1;\n    text-align: center;\n    margin-bottom: 10px;\n    }\n\n    .formulario-usuario-editar .form-group {\n    display: flex;\n    flex-direction: column;\n    }\n\n    .formulario-usuario-editar .form-group.full-width {\n    grid-column: 1 / -1;\n    }\n\n    .formulario-usuario-editar button {\n    width: 100%;\n    max-width: 187px;\n    justify-self: start;\n    }\n\n/* Tabla ancha reutilizable */\n.table-listado--wide {\n  width: 96% !important;\n  max-width: 1400px;\n  min-width: 1100px;\n  margin: 16px auto;\n}\n\n/* Quita límites antiguos de usuarios si te están estrechando la tabla */\n.gestion-usuarios .table-listado {\n  max-width: unset !important;\n  min-width: unset !important;\n}\n\n\n/* Toast minimalista */\n.toast {\n  position: fixed;\n  top: 20px; left: 50%;\n  transform: translateX(-50%);\n  z-index: 9999;\n  padding: 12px 18px;\n  border-radius: 8px;\n  color: #111;\n  background: #e8f6ff;\n  box-shadow: 0 8px 24px rgba(0,0,0,.12);\n  font-weight: 600;\n  animation: toastIn .2s ease-out;\n}\n.toast.ok    { background: #e7f8ed; color: #0f5132; border: 1px solid #b6f0c6; }\n.toast.error { background: #fdeceb; color: #842029; border: 1px solid #f5c2c7; }\n.toast.info  { background: #e8f6ff; color: #084298; border: 1px solid #b6d9ff; }\n\n@keyframes toastIn { from { opacity: 0; transform: translate(-50%, -6px); } to { opacity: 1; transform: translate(-50%, 0); } }\n\n/* Fade-in para el bloque activo */\n.ticaje-frame > * {\n  animation: fadeIn .18s ease-out;\n}\n@keyframes fadeIn { from { opacity: 0; transform: translateY(4px);} to { opacity: 1; transform: translateY(0);} }\n\n/* AVATARES */\n.avatar-lista {\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n}\n\n.avatar-lista img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-fallback {\n  width: 100%;\n  height: 100%;\n  border-radius: 999px;\n  background: #ddd;\n  color: #555;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n/* Fuerza que el contenido del nodo sea horizontal */\n.org-chart .nodo-org {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: #29a9ec;\n  color: #fff;\n}\n\n/* Avatar del nodo */\n.org-chart .nodo-org-avatar {\n  flex: 0 0 auto;\n}\n\n/* Reutilizamos el estilo de avatar de la tabla */\n.org-chart .avatar-lista {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e0e0e0;\n}\n\n.org-chart .avatar-lista img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.org-chart .avatar-fallback {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #d0d0d0;\n  color: #555;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n}\n\n/* Texto del nodo */\n.org-chart .nodo-org-texto {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.org-chart .nodo-org-nombre {\n  font-weight: 700;\n}\n\n.org-chart .nodo-org-rol {\n  opacity: 0.9;\n  font-size: 0.85em;\n}\n\n/* --- Corrección del ancho excesivo --- */\n.org-chart .nodo-org {\n  width: max-content;          /* La tarjeta ocupa sólo lo necesario */\n  max-width: 360px;            /* Evita tarjetas gigantes */\n  display: inline-flex !important;\n  flex-direction: row !important;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: #29a9ec;\n  color: #fff;\n  margin: 6px 0;\n  box-sizing: border-box;\n}\n\n/* Esto evita que <li> fuerce el ancho completo */\n.org-chart li {\n  width: auto;\n  display: block;\n}\n\n.nav-user-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.avatar-navbar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e0e0e0;\n}\n\n.avatar-navbar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-fallback-navbar {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #555;\n}\n\n.nav-user-name {\n  font-weight: 600;\n}\n\n.subtabla-centros--usuarios .th-avatar,\n.subtabla-centros--usuarios .td-avatar {\n  width: 56px !important;\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.subtabla-centros--usuarios td:nth-child(2) {\n  max-width: 260px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.avatar-lista img,\n.avatar-fallback {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n\n\n/* ----- Jornadas: columna Acciones ----- */\n.consulta-ticajes .table-listado td.botones-usuario--jornadas {\n  overflow: visible !important;      /* nada de recortes */\n  text-overflow: initial !important;\n  white-space: normal;               /* deja que el contenedor gestione el flujo */\n  padding-right: 0;                  /* coherencia con Usuarios */\n}\n\n/* Fila de botones (misma separación que Usuarios) */\n.consulta-ticajes .table-listado td.botones-usuario--jornadas .btn-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;                 /* todos en una línea */\n  gap: 6px;                          /* <- ajusta aquí si quieres más/menos aire */\n  min-width: 0;                      /* evita efectos colaterales del td */\n}\n\n/* Botones: que no sumen márgenes y se adapten al texto */\n.consulta-ticajes .table-listado td.botones-usuario--jornadas .btn-mapa {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;                         /* importante: que el gap mande */\n  width: auto !important;\n  min-width: max-content;            /* el ancho crece con el texto */\n  white-space: nowrap;               /* el texto no parte en varias líneas */\n  line-height: 1;                    /* evita cortes verticales raros */\n  padding: 8px 14px;                 /* look & feel como en Usuarios */\n}\n\n/* Alinear SIEMPRE a la izquierda en tablas de departamentos */\n.tabla-listado-clientes th,\n.tabla-listado-clientes td,\n.subtabla-centros--usuarios th,\n.subtabla-centros--usuarios td {\n  text-align: left !important;\n}\n\n/* Evitar centrado automático en columnas estrechas */\n.subtabla-centros--usuarios th.th-avatar,\n.subtabla-centros--usuarios td.td-avatar {\n  text-align: center !important; /* Solo el avatar centrado */\n}\n\n\n\n\n/* Ajustes */\n.ajustes {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n    .cambiar-contrasena {\n        width: auto;\n        margin-top: 10px;\n    }\n\n        .cambiar-contrasena h2 {\n            margin-bottom: 45px;\n        }\n    \n        .cambiar-contrasena form {\n            background: rgb(226, 226, 226);\n            margin-top: 20px;\n            padding: 20px;\n\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            gap: 0 20px;\n        }\n\n            .cambiar-contrasena .form-group {\n                grid-column: span 2;\n\n                display: grid;\n                grid-template-columns: subgrid;\n                align-items: center;\n                /* justify-items: center; */\n\n            }\n\n        .cambiar-contrasena button {\n            grid-column: span 2;\n            width: auto;\n\n        }\n\n\n/* Login */\n.layout_identificarse {\n\tbackground: rgb(226, 226, 226);\n\twidth: 360px;\n\theight: auto;\n\tmargin: 70px auto;\n\ttext-align: center;\n\tpadding: 20px;\n\n\tdisplay: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-evenly;\n\n}\n\n    .layout_identificarse h2 {\n    \tcolor: #41b6e6;\n        margin-top: 15px;\n        margin-bottom: 30px;\n    }\n    \n        .content-form .form-group {\n            display: grid;\n            grid-template-columns: 1fr 1fr 1fr;   \n            justify-items:flex-end;\n        }\n\n        .content-form div:last-child {\n            margin: 25px 0;\n        }\n\n            .content-form .form-group svg {\n                margin-right: 10px;\n            }\n\n\n/* Modal */\n.modal-overlay {\n    position: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: rgba(0, 0, 0, 0.3) !important;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n    .modal-close {\n        color: black;\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        background: none;\n        border: none;\n        font-size: 30px;\n        cursor: pointer;\n    }\n\n    .modal-content {\n        background-color: white !important;\n        width: 70% !important;\n        height: auto !important;\n        margin-bottom: -200px !important;\n        padding: 50px;\n        border-radius: 8px;\n        box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);\n        overflow-y: auto !important;\n\n        display: flex;\n        flex-flow: wrap row;\n        gap: 10px;\n    }\n        .modal-content form {\n            display: flex;\n            flex-direction: column;\n            gap: 20px;\n        }\n\n            .nombre-centro {\n                display: flex;\n                gap: 10px;\n            }\n\n            .modal-content form button {\n                width: 150px;\n            }\n\n            .modal-content .reset {\n                width: 100px;\n            }\n\n\n\n\n\n\n\n\n/* No tocar por ahora */\n.item-menu {\n    align-items: center !important;\n    transition: all 300ms ease;\n    align-self: center;\n}\n\n.item-menu:hover {\n    background: #2699c7;\n}\n\n#basic-navbar-nav {\n    background-color: #41b6e6;\n}\n\n.input-layout {\n    /* width: 70%; */\n\tpadding: 10px;\n\t/* margin-left: 7px; */\n\tborder: transparent;\n\tborder-bottom: 1px solid black;\n\ttransition: all 0.3s ease;\n\tbackground: rgb(227, 241, 243);\n}\n\n.input-layout:hover {\n    border: transparent;\n\tborder-bottom: 1px solid black;\n\tbackground: rgb(255, 255, 255);\n}\n\n.input-layout:focus {\n\toutline: none;\n\tborder-bottom: #2699c7 2px solid;\n\ttransition: none;\n\tbackground: white;\n}\n\n.input-layout:focus::placeholder {\n    transform: translateY(-15px);\n\tfont-size: 12px;\n\tcolor: #999;\n\ttransition: all 0.3s ease;\n}\n\n.icon-login {\n    align-self: center;\n}\n\n\n\n\n\n.iniciar-sesion {\n    color: black;\n\tmargin-right: 120px;\n}\n\n.iniciar-sesion:hover {\n    color: rgb(68, 68, 68);\n}\n\n.listado {\n    margin-top: 20px;\n\tmargin-bottom: 20px;\n}\n\n.tam {\n    width: 40% !important;\n}\n\n\n.tr-header-listado {\n\tbackground: #9de3ff;\n\tfont-size: 18px;\n    padding: 10px;\n    transition: all 0.3s;\n}\n\ntr:nth-child(even) {\n    background: #e6e6e6;\n}\n\n\n.th-header-listado:hover {\n    cursor: pointer;\n\tbackground: rgb(136, 207, 235);\n}\n\n.tr-body-listado td {\n    padding: 10px;\n\tborder-bottom: 1px solid rgb(155, 197, 199);\n}\n\n/* Alternar colores en filas */\n.tr-body-listado:nth-child(even) {\n    background: #f8f8f8;\n}\n\n.tr-body-listado:nth-child(odd) {\n\tbackground: #ffffff;\n}\n\n/* Alinear correctamente los centros */\n.tr-body-listado.centro-trabajo {\n    background: #e6e6e6;\n\tpadding-left: 120px;\n}\n\n.subtabla-centros {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 0;\n    padding: 0;\n    background-color: transparent;\n}\n\n.subtabla-centros th,\n.subtabla-centros td {\n    padding: 10px 8px;\n    border: none;\n    background: none;\n    text-align: left;\n}\n\n/* Fondo alterno por filas */\n.subtabla-centros tbody tr:nth-child(even) {\n    background-color: #f5f5f5;\n}\n.subtabla-centros tbody tr:nth-child(odd) {\n    background-color: transparent;\n}\n\n/* Columnas: centro amplio, jornadas estrecho, acciones medio */\n.subtabla-centros th:nth-child(1),\n.subtabla-centros td:nth-child(1) {\n    width: 60%;\n}\n\n.subtabla-centros th:nth-child(2),\n.subtabla-centros td:nth-child(2) {\n    width: 10%;\n    text-align: center;\n}\n\n.subtabla-centros th:nth-child(3),\n.subtabla-centros td:nth-child(3) {\n    width: 30%;\n    text-align: right;\n}\n\n\n.form-agregar-tag {\n    width: 500px;\n\tfont-weight: 600;\n    margin-top: 100px;\n}\n\n.form-agregar-tag select {\n    margin-top: 10px;\n}\n\n.form-agregar-tag button {\n    /* width: 120px !important; */\n\tmargin-right: 30px !important;\n\tmargin-top: 20px;\n}\n\n/* Contenedor de botones en cada fila */\n.button-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 5px;\n}\n\n.gestion-usuarios .table-listado td.acciones-grid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, 91px);\n\tgap: 5px;\n}\n\n\n/* Organigrama */\n.org-chart ul {\n  list-style: none;\n  padding-left: 20px;\n  position: relative;\n}\n\n.org-chart ul::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 10px;\n  border-left: 2px solid #ccc;\n  bottom: 0;\n}\n\n.org-chart li {\n  margin: 10px 0;\n  padding-left: 20px;\n  position: relative;\n}\n\n.org-chart li::before {\n  content: '';\n  position: absolute;\n  top: 10px;\n  left: 0;\n  width: 10px;\n  height: 2px;\n  background: #ccc;\n}\n\n.nodo-org {\n  background: #41b6e6;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 5px;\n  font-weight: bold;\n  display: inline-block;\n}\n\n/* Desplegable Intervenciones */\n/* Contenedor principal del select */\n.select-orden {\n  width: 100%;\n}\n\n/* Estilo del control visible */\n.select__control {\n  min-height: 44px;\n  font-size: 15px;\n  width: 100%;\n  border: 1px solid rgb(187, 187, 187);\n  background-color: #e3f1f3; /* como los otros inputs */\n}\n\n/* Borde al hacer foco */\n.select__control--is-focused {\n  border-color: #2699c7;\n  box-shadow: 0 0 0 1px #2699c7;\n}\n\n/* Texto seleccionado */\n.select__single-value {\n  white-space: normal;\n  font-size: 15px;\n}\n\n/* Menú desplegable */\n.select__menu {\n  z-index: 9999;\n}\n\n/* Opciones dentro del menú */\n.select__option {\n  font-size: 15px;\n  padding: 8px 10px;\n}\n\n\n/* Logs */\n.logs {\n    max-width: 1000px !important;\n}\n\n\n/* Calendario */\n.turnos-modal-backdrop {\n  position: fixed;\n  top: 0; left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(40,40,70,0.45);\n  z-index: 9988;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.turnos-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 2rem 1.5rem;\n  min-width: 340px;\n  max-width: 92vw;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.16);\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  gap: 1.3rem;\n  font-size: 1rem;\n}\n.turnos-modal label {\n  display: block;\n  margin-top: 10px;\n  color: #222;\n  font-weight: 500;\n}\n.turnos-modal input,\n.turnos-modal select {\n  margin-top: 6px;\n  padding: 0.5em;\n  border: 1px solid #aaa;\n  border-radius: 6px;\n  width: 100%;\n  font-size: 1em;\n}\n.turnos-modal button {\n  margin-top: 12px;\n  margin-right: 10px;\n  padding: 0.4em 1.2em;\n  border: none;\n  border-radius: 6px;\n  background: #3498db;\n  color: #fff;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.turnos-modal button[type=\"button\"] {\n  background: #aaa;\n}\n.turnos-modal button:hover {\n  background: #217dbb;\n}\n\n/* Altura del área del calendario sin pisar el footer */\n.cal-wrapper{\n  /* resta cabecera + nav + footer aprox.; ajusta si lo necesitas */\n  height: calc(100vh - 220px);\n  min-height: 640px;   /* asegura espacio cómodo en pantallas pequeñas */\n  padding: 1rem;\n}\n\n/* Asegúrate de que el área de contenido pueda hacer scroll si lo necesita */\n.layout-content{\n  overflow: auto;\n}\n\n/* RBC: que la rejilla vertical tenga su propio scroll si hace falta */\n.rbc-time-content{\n  overflow-y: auto;\n}\n\n/* Un pequeño colchón para que no “toque” el borde inferior */\n.rbc-time-view{\n  padding-bottom: 8px;\n}\n\n\n.alerta {\n  background-color: #f8d7da; /* rojo suave */\n  color: #721c24;           /* texto rojo oscuro */\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  padding: 10px 15px;\n  margin: 15px 0;\n  text-align: left;\n  font-weight: 500;\n}\n\n/* Selects React */\n\n/* ========== Anchos unificados para react-select en el formulario manual ========== */\n.form-jornada-manual .select-usuario,\n.form-jornada-manual .select-cliente,\n.form-jornada-manual .select-orden,\n.form-jornada-manual .select-centro {\n  display: block;   /* react-select usa inline-block por defecto */\n  width: 100%;      /* mismo ancho que .input-layout */\n}\n\n/* (Opcional) Alinea alturas/estilos del control para que se vea como los inputs */\n.form-jornada-manual .select__control {\n  min-height: 40px;       /* ajusta si tu .input-layout usa otra altura */\n  border-radius: 4px;\n}\n\n/* (Opcional) Haz que el menú no recorte dentro de contenedores con overflow */\n.form-jornada-manual .select__menu {\n  z-index: 5; /* sube si tienes modales o contenedores con z-index alto */\n}\n\n/* ========== Anchos unificados para react-select en formulario de iniciar jornada ========== */\n.registro-fecha .select-usuario,\n.registro-fecha .select-cliente,\n.registro-fecha .select-orden,\n.registro-fecha .select-centro {\n  display: block;\n  width: 100%;\n}\n\n/* Opcional: alinear alturas/estilos */\n.registro-fecha .select__control {\n  min-height: 40px;\n  border-radius: 4px;\n}\n\n.registro-fecha .select__menu {\n  z-index: 5;\n}\n\n/* === Utilidad reusable para react-select ===\n   Úsala añadiendo `rs-full` al className del <Select /> */\n.rs-full { \n  display: block;\n  width: 100%;\n}\n\n/* Ajustes del control para que se parezca a .input-layout */\n.rs-full.select__control {\n  min-height: 40px;\n  border-radius: 4px;\n}\n\n/* Evita que el menú quede oculto en contenedores con overflow/posicionamiento */\n.rs-full.select__menu {\n  z-index: 5;\n}\n\n\n/* Media queries */\n\n@media all and (max-width: 1340px) {\n    .navbar-nav a{\n        font-size: 14px !important;\n        padding: 10px 12px !important;\n    }\n}\n\n@media all and (max-width: 1265px) {\n\n\n    .navi button {\n        margin-bottom: 5px;\n        border: 1px solid black;\n        background: rgb(55, 165, 210);\n    }\n\n    .table-listado-padre {\n        max-width: 100%;\n        overflow-x: auto;\n    }\n\n    .table-listado {\n        width: 100%;\n    }\n\n    .gestion-usuarios .table-listado {\n        /* min-width: auto !important; */\n        /* padding-right: 50px !important; */\n    }\n\n    .acciones-td {\n        white-space: nowrap; /* Evita que los botones se dividan en varias líneas */\n        text-align: center;\n    }\n}\n\n@media all and (max-width: 1190px) {\n    .navi a {\n        padding-left: 10px;\n\t}\n\n    .acciones-td {\n        /* flex-direction: column; */\n        width: 75%;\n    }\n\n}\n\n@media all and (max-width: 995px) {\n    /* .title-listado {\n\t\tmargin-left: 20px;\n\t\tmargin-left: 100px;\n\t} */\n\n\t.table-listado {\n        font-size: 14px;\n\t\twidth: 95%;\n\t\tpadding: 0px;\n\t}\n\n    .ticaje-proceso .table-listado {\n        width: 100%;\n    }\n\n\t.th-header-listado {\n        font-size: 14px;\n\t}\n\n\t.item-nav {\n        padding: 10px 30px !important;\n\t}\n    \n}\n\n@media all and (max-width: 941px) {\n    .registro-usuarios .modal-form {\n        display: grid;\n        grid-template-columns: auto 1fr;\n    }\n\n    .registro-usuarios .modal-form button {\n        grid-column: span 2;\n    }\n\n}\n\n@media all and (max-width: 912px) {\n    .editar-user .modal-options {\n        display: grid;\n        grid-template-columns: auto 1fr;\n        justify-content: center;\n        padding: 0 60px;\n    }\n}\n\n@media all and (max-width: 831px) {\n    .filtros {\n        grid-template-columns: repeat(2, auto 1fr);\n        grid-template-rows: repeat(2, auto);\n        gap: 5px 10px;\n    }\n\n        .filtros input, .filtros select {\n            margin-right: 5px;\n        }\n}\n\n@media all and (max-width: 758px) {\n    .exportar-botones {\n        flex-wrap: wrap;\n    }\n\n        .exportar-botones button {\n            font-size: 10px;\n        }\n}\n\n@media all and (max-width: 744px) {\n    .exportar-botones {\n        width: 100%;\n        grid-template-columns: repeat(2,1fr);\n        gap: 10px 20px;\n    }\n}\n\n@media all and (max-width: 731px) {\n\n    .form-agregar-cliente {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .tabla-clientes {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .acciones-td {\n        flex-direction: column;\n        max-width: 90%;\n        width: 100%;\n    }\n    .tabla-clientes .table-listado-padre {\n        width: 90%;\n    }\n\n    .modal-content {\n        width: 100% !important;\n    }\n}\n\n@media all and (max-width: 676px) {\n    \n    .registro-fecha {\n\t\twidth: 400px;\n\t\tfont-size: 14px;\n\t}\n}\n\n@media all and (max-width: 550px) {\n    .filtros {\n        grid-template-columns: auto 1fr;\n    }\n}\n\n\n@media all and (max-width:521px) {\n    .ticaje-proceso .table-listado td, \n    .ticaje-proceso .table-listado th {\n        width: 24%;\n    }\n}\n\n@media all and (max-width: 500px) {\n    \n    .registro-fecha {\n        width: 340px;\n\t\t/* font-size: 14px; */\n\t}\n    \n\t.form-tag {\n        width: 300px !important;\n\t\tmargin-left: 30px;\n\t}\n    \n\t.form-tag input {\n        width: 90%;\n        \n\t}\n\n    .modal-content {\n        padding: 0px;\n    }\n\n    .registro-usuarios .modal-form {\n        padding: 10px;\n    }\n\n    .registro-usuarios .modal-form * {\n        margin: 0;\n    }\n\n    .registro-usuarios .modal-form button {\n        margin: 0;\n    }\n\n    .modal-content h3 {\n        margin: 20px;\n    }\n\n    .modal-centro input{\n        height: 25px;\n    }\n    \n    .modal-content label {\n        margin-left: 20px;\n    }\n\n    .modal-content button {\n        margin: 0 0 20px 20px;\n    }\n\n    .modal-options button,\n    .editar-user button {\n        margin: 0;\n    }\n\n    .modal-options label {\n        margin: 0;\n    }\n\n    .listado-container .modal-content {\n        padding: 10px;\n    }\n\n    .listado-container .modal-content .btn-login {\n        margin-left: 0;\n    }\n}\n\n@media all and (max-width: 482px) {\n    .formulario-usuario {\n        grid-template-columns: 1fr;\n    }\n\n    .formulario-usuario .form-group {\n        flex-direction: column;\n    }\n    .formulario-usuario .form-group select {\n        max-width: 100%;\n    }\n    .formulario-usuario .btn-login {\n        max-width: 100%;\n    }\n}\n\n@media all and (max-width: 445px) {\n\n    .modal-content {\n        width: 100% !important;\n        /* height: 92% !important; */\n    }\n\n    .leaflet-container {\n        height: 250px !important;\n    }\n    \n    .reset {\n        width: 50px !important;\n    }\n    .glass {\n        min-width: 50% !important;\n        width: 50% !important;\n    }\n}\n\n@media all and (max-width: 428px) {\n\n    h2.centrar-titulo {\n        margin-left: 20px;\n    }\n\n    .formulario-ticaje {\n        width: 100%;\n    }\n\n    .form-orden {\n        width: 100%;\n    }\n\n        .form-orden h2 {\n            width: 95%;\n            margin: 0 auto;\n        }\n\n    .registro-fecha {\n        margin-top: 60px !important;\n        width: 100%;\n    }\n\n    .ticaje-proceso {\n        width: 100%;\n    }\n\n        .ticaje-proceso p {\n            margin-left: 30px;\n        }\n\n    .table-listado {\n        font-size: 14px;\n        /* margin:0 auto; */\n    }\n\n    .form-agregar-cliente input {\n        height: 35px;\n        width: 155px;\n        font-size: 12px;\n    }\n    .form-agregar-cliente button {\n        font-size: 12px;\n        height: 35px;\n        padding: 0 15px;\n    }\n\n    .editar-user button:last-child {\n        width: 50%;\n        margin: 0 auto 20px;\n    }\n\n    .editar-user .modal-options {\n        padding: 0 10px;\n    }\n    \n}\n\n@media all and (max-width: 401px) {\n    .layout_identificarse {\n        width: 100%;\n        margin: 0;\n    }\n\n    .layout {\n        grid-template-rows: 100px 70px 1fr 100px;\n    }\n    .footer {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        line-height: 30px;   \n    }\n}\n\n@media all and (max-width: 378px) {\n    .form-agregar-tag {\n        margin: 50px 0;\n    }\n}\n\n@media all and (max-width: 360px) {\n    .layout_identificarse {\n        width: 100%;\n    }\n\n    .consulta-ticajes .filtros {\n        grid-template-columns: 1fr;\n    }\n\n    .cambiar-contrasena form {\n        grid-template-columns: 1fr !important;\n    }\n\n    .cambiar-contrasena .form-group {\n        grid-column: 1;\n    }\n}\n\n@media all and (max-width: 347px) {\n    .listado-container .modal-content .checkbox-group {\n        grid-template-columns: 1fr;\n    }\n}\n\n\n/* Cementerio de clases */\n\n/* .nav {\n    background-color: #41b6e6;\n} */\n\n/* .nav ul {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    list-style: none;\n} */\n\n/* .nav a {\n    display: block;\n    margin-left: 30px;\n    margin-right: 30px;\n    color: white;\n    text-decoration: none;\n    font-size: 18px;\n    font-weight: bold;\n    transition: all 300ms;\n}\n\n.nav a:hover {\n    transform: scale(1.3, 1.3)\n} */\n\n.nav-dropdown .dropdown-menu {\n    background-color: #41b6e6;\n    color: white;\n} \n.nav-dropdown:hover {\n    display: block;\n}\n\n\n.custom-nav-dropdown .dropdown-item {\n    background-color: #41b6e6;\n    color: black;\n}\n\n/* .sub-menu {\n    padding: 0px !important;\n} */\n\n/* .block {\n    background: #9de3ff !important;   \n}\n\n.block:hover {\n    cursor: default !important;\n    background: #9de3ff !important;\n} */\n            \n/* .mr-auto {\n    min-height: 15px;\n    background-color: #41b6e6;\n\n} */\n\n/* .content-ajustes {\n\tmargin: 20px 100px;\n\tdisplay: flex;\n\tjustify-content: start;\n} */\n\n/* .marco-mapa {\n    height: 700px;\n    width: 100%;\n    align-items: center;\n} */\n\n/* .leaflet-container {\n    display: block;\n\twidth: 100%;\n\tmin-width: 600px;\n} */\n\n/* .butt{\n    background-color: #41b6e6;\n    color: white;\n    border: 0;\n    outline: 0;\n  padding: 15px;\n  border-radius: 5px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 300ms;\n  \n} */\n\n/* form {\n\tpadding: 10px;\n\tmargin: 5px;\n\tmargin-left: 15px;\n\tdisplay: block;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 15px;\n} */\n\n/* form button,\nform input[type=\"submit\"],\nform input[type=\"button\"] {\n\tbackground-color: #41b6e6;\n\tcolor: white;\n\tborder: 0;\n\toutline: 0;\n\tpadding: 8px 15px;\n\tborder-radius: 5px;\n\tmargin-top: 15px;\n\tmargin: 15px;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcursor: pointer;\n\ttransition: all 300ms;\n} */\n\n/* .paginador button,\n.paginador form input[type=\"submit\"],\n.paginador form input[type=\"button\"] {\n    background-color: #41b6e6;\n\tcolor: white;\n\tborder: 0;\n\toutline: 0;\n\tpadding: 15px;\n\tborder-radius: 5px;\n\tmargin-top: 15px;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcursor: pointer;\n\ttransition: all 300ms;\n}\n\n.paginador>* {\n\tmargin: 0 10px;\n    \n} */\n\n\n/* .layout_identificarse h2 {\n\tmargin-bottom: 20px;\n\tcolor: #41b6e6;\n} */\n\n/* .label-layout {\n    text-align: start;\n} */\n\n/* button .navbar-toggle:focus {\n    border: 0px;\n\t;\n} */\n\n/* app/listadotrabajos */\n/* .input-mostrar {\n    margin-top: -10px;\n} */\n\n/* .title-listado {\n\tmargin-left: 300px;\n\tmargin-bottom: 35px;\n\ttext-transform: uppercase;\n\tletter-spacing: 1.5px;\n} */\n\n/*app/listamatricula */\n/* .lista-matricula-content {\n    display: flex;\n\tbackground: red;\n} */\n\n/* .matricula-form {\n    display: flex;\n\tflex-flow: wrap row;\n\tbackground: rgb(213, 219, 220);\n\twidth: 350px;\n\tmargin-bottom: 30px;\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tmargin: 0px auto;\n\tmargin-bottom: 20px;\n} */\n\n/* .matricula-form label {\n\tflex: 1 100%;\n\tmargin-bottom: 10px;\n\tmargin-left: 30px;\n} */\n\n/* .buscar-listado {\n    display: flex;\n\twidth: auto;\n\tjustify-self: end;\n} */\n\n/* .btn-fecha {\n    justify-self: center;\n} */\n\n/* .mostrar-todos {\n    grid-row: 2/3;\n\twidth: 150px;\n} */\n\n/* .listado-clientes ul {\n    list-style-type: none;\n\tpadding: 0;\n} */\n\n/* .cliente-item {\n\tmargin-bottom: 20px;\n\tpadding: 10px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 5px;\n} */\n\n/* .cliente-header {\n    display: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n} */\n\n/* .btn-expand {\n    background-color: #41b6e6;\n\tcolor: white;\n\tborder: none;\n\tpadding: 5px 10px;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\ttransition: background-color 0.3s ease;\n}\n\n.btn-expand:hover {\n    background-color: #2699c7;\n} */\n\n/* .lugares-list {\n    margin-top: 10px;\n\tpadding-left: 20px;\n} */\n\n/* .lugar-item {\n    margin-bottom: 5px;\n} */\n\n/* .btn-atras:hover,\ninput[type=\"submit\"]:hover,\nbutton[type=\"submit\"]:hover {\n    background: #3f92ca !important;\n}\n\n.btn-atras {\n    margin-top: 0px !important;\n    \n} */\n\n/* .paginador {\n    margin: 15px;\n\tmargin-left: 15px;\n\t;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 15px;\n} */\n\n/* .num-pag,\n.pag-previus,\n.pag-next {\n    background: rgb(238, 238, 238) !important;\n\tcolor: black !important;\n} */\n\n/* .num-pag {\n    padding: 5px 10px !important;\n\theight: 33px !important;\n\tborder-radius: 0px !important;\n\tmargin-top: 0px !important;\n\tmargin-right: 5px !important;\n\tmargin-left: 0px !important;\n    \n} */\n\n/* .num-pag:hover {\n    background: rgb(193, 193, 193) !important;\n} */\n\n/* ico-pag {\n    font-size: 16px !important;\n} */\n\n/* .pag-previus,\n.pag-next {\n    height: 33px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin: 0px !important;\n\tmargin-right: 5px !important;\n} */\n\n/* .pag-next:hover,\n.pag-previus:hover {\n    background: rgb(193, 193, 193) !important;\n} */\n\n/* .lateral {\n\tmin-width: 200px;\n} */\n\n/* app/listaportag */\n/* .form-tag {\n    width: 450px;\n\tfont-weight: 600;\n} */\n\n/* .form-tag input {\n    grid-column: 1/2;\n} */\n\n/* app/formtags */\n/* .tr-body-tags td {\n    padding-left: 15px !important;\n\tpadding: 10px;\n} */\n\n/* .button-delete {\n    background: transparent !important;\n\tcolor: rgb(0, 0, 0) !important;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 20px !important;\n    \n} */\n\n/* .ico-modificar {\n    color: black;\n\tfont-size: 20px;\n} */\n\n/* .ico-delete {\n    transition: all 300ms ease;\n} */\n\n/* .ico-delete:hover,\n.ico-modificar:hover {\n    color: rgb(83, 83, 83) !important;\n} */\n\n/* .btn-atras,\ninput[type=\"submit\"] {\n    width: 50%;\n\tjustify-self: end;\n} */\n\n/* Botones */\n/* .btn-mostrar-lugares {\n    background: #41b6e6;\n\tcolor: white;\n\tborder: none;\n\tpadding: 8px 10px;\n\tborder-radius: 4px;\n\tcursor: pointer;\n} */\n\n/* .btn-agregar-centro {\n\tbackground: #28a745;\n\tcolor: white;\n} */\n\n/* .btn-eliminar-cliente,\n.btn-eliminar-centro {\n    background: #dc3545;\n\tcolor: white;\n} */\n\n/* Separar clientes de sus centros */\n/* .lugar-row td {\n    padding-left: 40px !important;\n\tbackground: #eeeeee;\n} */\n\n/* .icon-mostrar {\n    background: transparent !important;\n\tcolor: rgb(0, 0, 0) !important;\n\tfont-size: 20px !important;\n} */\n\n/* .perido {\n    flex: 1 1 50% !important;\n} */\n\n/* .closeButton {\n    position: absolute;\n\ttop: 10px;\n\tright: 10px;\n\tborder: none;\n\tcursor: pointer;\n\tfont-size: 16px;\n\tbackground: white;\n\tcolor: black;\n} */\n\n/* .open-button {\n    padding: 10px 20px;\n\tbackground-color: #007bff;\n\tcolor: white;\n\tborder: none;\n\tborder-radius: 4px;\n\tcursor: pointer;\n} */\n\n/* .open-button:hover {\n    background-color: #0056b3;\n} */\n\n/* Ajustes */\n\n\n/* .perfil h2 {\n\twidth: 80%;\n\tmargin-bottom: 20px;\n} */\n\n/* .contraseña h4 {\n    text-align: center;\n} */\n\n/* .formulario-contraseña {\n    display: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgrid-template-rows: 1fr auto;\n\tgap: 15px;\n}\n\n.form-contraseña.label {\n    grid-column: 1/2;\n\tgrid-row: 1/2;\n\ttext-align: end;\n}\n\n.form-contraseña.label label {\n\tmargin-bottom: 10px;\n}\n\n.form-contraseña.input {\n    grid-column: 2/3;\n\tgrid-row: 1/2;\n}\n\n.input-guardar {\n    grid-column: 2/3;\n\tgrid-row: 2/3;\n}\n\n.input-guardar input[type='submit'] {\n\tmargin: 0;\n}\n\n.form-contraseña.input input {\n    margin-bottom: 10px;\n} */\n\n\n\n/* @media all and (max-width: 944px) {\n    .crea-form {\n\t\twidth: 280px;\n\t\tfont-size: 14px;\n\t\tmargin: 0px 40px 40px 40px;\n\t}\n    \n\t.crea-form button {\n        font-size: 14px;\n\t}\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
